const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHostel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2475 1650",
    style: {
      enableBackground: "new 0 0 2475 1650"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 2475,
    height: 1650
  })), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -3676.687,
    y1: 1794.7494,
    x2: -1466.7781,
    y2: 189.9344,
    gradientTransform: "matrix(-1 0 0 1 -1250.9832 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "currentColor"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M183.241,754.321c58.162-79.759,181.433-122.493,184.634-242.024 c2.081-77.671-33.813-119.767,23.624-186.068c138.844-160.266,352.808-179.047,535.501-112.097 c182.632,66.928,328.582,201.088,531.632,193.002c110.578-4.404,213.313-55.947,322.771-65.619 c33.72-2.979,65.227-0.424,94.691,6.989c110.449,27.789,207.969,132.137,244.692,248.066 c29.768,93.976-8.265,186.747,38.477,278.773c49.82,98.087,147.932,166.218,172.651,279.46 c29.668,135.915-83.684,254.11-205.445,257.806c-77.503,2.352-221.163-9.808-287.004-56.776 c-80.171-57.19-158.965-60.951-252.426-58.76c-177.865,4.17-355.724,43.481-531.295,71.471 c-150.443,23.983-298.723,59.499-451.192,64.009c-111.973,3.312-206.998,4.801-267.588-114.651 C264.546,1175.127,61.248,921.613,183.241,754.321z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1679.23,1117.077c-0.73-17.585,7.387-34.449,21.772-44.274 c36.591-24.991,70.107-59.227,96.882-101.442c52.654-83.02,66.88-177.367,45.448-253.252 c-5.391-19.088,0.343-39.523,15.037-52.632c38.919-34.718,76.093-82.678,105.843-140.023 c76.342-147.153,74.884-300.309-3.256-342.083c-78.14-41.774-203.372,43.653-279.714,190.807 c-30.345,58.492-48.391,117.927-54.219,170.942c-2.228,20.265-15.903,37.19-35.029,43.423 c-63.807,20.794-125.612,68.51-169.394,137.542c-12.265,19.338-22.441,39.292-30.569,59.483 c-7.121,17.689-23.455,29.805-42.214,31.395c-98.171,8.318-193.393,63.288-252.702,156.801 c-98.682,155.591-60.576,358.911,85.111,454.128c145.687,95.217,343.787,46.274,442.468-109.317 C1664.529,1255.769,1682.057,1185.188,1679.23,1117.077z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169555888679915737220000015757039471602252683_",
    gradientUnits: "userSpaceOnUse",
    x1: 1208.4235,
    y1: 814.2172,
    x2: 1893.2644,
    y2: 814.2172
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "currentColor"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000169555888679915737220000015757039471602252683_)"
    },
    d: "M1893.176,358.06 c-7.356,23.163-15.807,45.879-24.632,68.456c-8.855,22.56-18.146,44.946-27.953,67.097 c-19.567,44.325-40.807,87.888-63.502,130.657c-22.661,42.79-46.999,84.665-72.733,125.631 c-3.221,5.118-6.34,10.303-9.645,15.366l-9.907,15.195c-6.601,10.132-13.15,20.3-20.062,30.22l-10.232,14.972 c-3.44,4.97-6.751,10.034-10.326,14.905l-21.135,29.464c-3.468,4.953-7.213,9.695-10.818,14.543l-10.919,14.467 c-3.668,4.799-7.262,9.658-10.991,14.409l-11.304,14.16l-11.304,14.16l-5.652,7.079c-1.897,2.349-3.875,4.63-5.808,6.948 l-23.326,27.712c-3.831,4.67-7.934,9.097-11.92,13.628l-12.03,13.53l-12.03,13.529c-4.066,4.457-8.25,8.804-12.369,13.21 l-24.831,26.33l-25.607,25.554c-4.302,4.222-8.479,8.576-12.884,12.689l-13.2,12.354l-13.198,12.353l-6.599,6.176l-3.299,3.087 l-3.389,2.988l-27.16,23.834l-6.789,5.958l-3.394,2.979l-3.488,2.866l-13.962,11.452l-13.985,11.42l-6.996,5.704 c-2.325,1.91-4.655,3.813-7.075,5.6l-28.742,21.823c-4.811,3.606-9.53,7.339-14.416,10.842l-14.743,10.382l-29.529,20.684 c-0.833,0.583-1.973,0.371-2.547-0.474c-0.567-0.834-0.37-1.973,0.436-2.563l0.055-0.04l29.046-21.224l14.545-10.572 c4.818-3.564,9.47-7.359,14.213-11.026l28.323-22.181c2.385-1.816,4.68-3.749,6.969-5.688l6.888-5.79l13.783-11.568 l13.806-11.536l3.449-2.886l3.355-3l6.71-5.998l26.839-23.99l3.348-3.006l3.259-3.106l6.517-6.213l13.034-12.424l13.033-12.422 c4.349-4.136,8.471-8.512,12.717-12.755l25.331-25.614l24.646-26.294c4.088-4.4,8.241-8.74,12.276-13.19l11.938-13.509 l11.938-13.508c3.955-4.523,8.027-8.944,11.828-13.605c31.26-36.548,60.838-74.529,89.552-113.157 c56.972-77.627,108.363-159.437,154.382-244.249c22.984-42.425,44.422-85.713,64.395-129.687 c10.066-21.95,19.621-44.142,28.743-66.513c2.295-5.587,4.557-11.188,6.741-16.819c2.232-5.613,4.405-11.249,6.538-16.899 c4.306-11.284,8.49-22.63,12.314-34.064l0.004-0.012c0.325-0.971,1.365-1.492,2.323-1.163 C1892.97,356.056,1893.482,357.096,1893.176,358.06z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2144.76,1049.426c27.371-54.471,32.343-113.436,18.032-162.539 c-2.895-9.932,0.161-20.399,7.819-26.964c20.921-17.933,40.62-43.441,57.278-76.593c47.542-94.614,52.326-215.619-2.51-244.014 c-54.836-28.395-148.527,46.574-196.07,141.188c-14.569,28.994-23.108,56.464-26.371,81.443 c-1.375,10.518-8.832,18.96-19.165,21.807c-52.253,14.4-101.791,54.973-131.549,114.194 c-10.436,20.769-17.612,42.192-21.707,63.472c-2.441,12.687-13.613,21.575-26.878,21.207 c-80.405-2.232-157.106,39.008-194.563,113.146c-53.125,105.151-5.195,239.47,105.183,294.882 c109.028,54.734,238.982,15.275,291.39-89.023c19.321-38.45,25.419-80.387,20.032-120.894 c-1.528-11.492,4.416-22.332,14.854-27.146C2082.337,1134.317,2120.256,1098.194,2144.76,1049.426z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039122999120982890260000006644956166187504531_",
    gradientUnits: "userSpaceOnUse",
    x1: 1699.1901,
    y1: 978.8858,
    x2: 2174.3225,
    y2: 978.8858
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "currentColor"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039122999120982890260000006644956166187504531_)"
    },
    d: "M2174.323,653.266 c-4.574,16.584-9.954,32.877-15.574,49.092c-5.575,16.232-11.709,32.249-17.969,48.217 c-12.714,31.851-26.453,63.296-41.475,94.116c-29.865,61.723-64.171,121.325-103.117,177.83 c-19.279,28.387-40.244,55.621-62.052,82.144c-21.863,26.485-45.207,51.788-69.786,75.842 c-6.216,5.949-12.37,11.953-18.63,17.847l-19.27,17.184c-6.357,5.794-13.146,11.12-19.812,16.572l-10.018,8.148l-5.007,4.072 l-5.18,3.871l-20.806,15.342c-3.414,2.619-7.07,4.933-10.636,7.356l-10.763,7.177l-10.781,7.132 c-3.599,2.366-7.388,4.469-11.069,6.715l-22.318,13.096l-0.871-1.313l20.977-14.901c3.485-2.489,7.072-4.831,10.468-7.434 l10.16-7.837l10.178-7.79c3.383-2.607,6.851-5.102,10.076-7.901l19.663-16.37l4.934-4.062l4.761-4.262l9.518-8.52 c6.328-5.694,12.77-11.255,18.781-17.281l18.429-17.63c5.985-6.034,11.86-12.174,17.792-18.251c2.94-3.064,5.96-6.05,8.834-9.176 l8.59-9.403l8.613-9.378c2.871-3.125,5.771-6.223,8.495-9.481l16.597-19.305c2.809-3.18,5.432-6.517,8.103-9.814l8.029-9.874 l8.064-9.845l7.791-10.062c5.15-6.743,10.444-13.375,15.475-20.207l14.997-20.567c4.987-6.863,9.766-13.879,14.663-20.809 c19.379-27.871,37.714-56.477,55.209-85.608c17.483-29.141,33.999-58.878,49.868-88.982c15.729-30.178,30.798-60.74,44.916-91.78 c3.608-7.725,7.001-15.549,10.491-23.333l10.105-23.519c1.683-3.923,3.324-7.863,4.935-11.817 c1.641-3.942,3.233-7.904,4.823-11.868c3.225-7.909,6.311-15.886,9.3-23.883L2174.323,653.266z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M509.282,1126.166c-99.881,43.777-263.582-85.815-275.818-208.121 c-4.793-47.913,16.21-69.195,4.959-136.944c-13.651-82.201-51.356-91.727-54.793-156.379 c-3.023-56.866,21.157-143.374,83.786-168.229c58.512-23.222,128.273,16.224,157.624,64.478 c30.85,50.719,1.508,85.607,32.092,143.986c30.242,57.725,74.581,53.488,109.854,94.138 C644.632,848.578,613.275,1080.586,509.282,1126.166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M535.648,1076.946c-10.858,13.057-22.763,22.482-35.385,28.014 c-31.637,13.867-75.892,6.255-121.414-20.883c-66.308-39.529-116.784-108.764-122.747-168.367 c-1.744-17.427,0.587-30.913,3.286-46.529c4.001-23.151,8.536-49.39,1.473-91.919c-7.468-44.969-22.039-71.103-33.747-92.103 c-11.221-20.123-19.326-34.663-20.763-61.682c-1.854-34.895,8.633-87.463,36.041-120.422c9.743-11.717,20.95-20.146,33.311-25.05 c21.127-8.385,46.739-6.615,72.12,4.985c23.74,10.85,45.369,29.584,57.857,50.116c12.182,20.027,12.436,36.591,12.759,57.561 c0.368,23.963,0.785,51.123,18.605,85.136c20.8,39.703,47.869,54.906,71.754,68.319c15.568,8.744,29.014,16.295,41.115,30.24 c26.426,30.455,40.321,85.691,37.172,147.759C583.939,984.119,564.71,1041.998,535.648,1076.946z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M280.514,523.228c17.119,45.802,33.828,91.691,50.477,137.569l25.126,68.744 l12.605,34.343c4.266,11.421,8.57,22.826,12.749,34.28c4.152,11.466,8.572,22.821,12.9,34.214l6.517,17.081 c2.106,5.721,4.352,11.381,6.548,17.064l13.238,34.075c4.62,11.265,9.05,22.614,13.586,33.922 c18.377,45.122,37.343,89.97,58.072,134.159l-2.66,1.481c-6.192-10.524-12.266-21.138-18.311-31.783 c-3.125-5.273-5.836-10.75-8.67-16.17l-8.455-16.292l-4.205-8.162c-1.398-2.724-2.789-5.451-4.081-8.222l-7.92-16.558 c-5.281-11.039-10.591-22.081-15.465-33.302c-4.946-11.192-9.999-22.343-14.861-33.578l-14.098-33.898 c-2.334-5.657-4.745-11.284-6.965-16.984l-6.677-17.098c-4.435-11.405-8.964-22.776-13.22-34.247 c-17.488-45.718-33.305-92.053-48.368-138.619c-7.533-23.284-14.67-46.698-21.533-70.195 c-6.772-23.529-13.435-47.081-19.226-70.912L280.514,523.228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M286.245,591.405c-29.748-15.16-53.168-45.452-53.402-45.756l1.197-0.946 c0.232,0.302,23.449,30.325,52.884,45.325L286.245,591.405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M291.224,628.508c-43.189-15.514-69.326-51.05-69.585-51.406l1.221-0.914 c0.256,0.354,26.134,35.517,68.869,50.868L291.224,628.508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M300.828,673.896c-51.779-11.438-80.979-57.201-81.268-57.662l1.28-0.826 c0.286,0.456,29.163,45.684,80.309,56.982L300.828,673.896z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M317.938,714.425c-50.336-3.569-85.701-47.588-86.051-48.031l1.182-0.965 c0.348,0.44,35.311,43.937,84.976,47.459L317.938,714.425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M331.154,751.242c-32.512-0.017-65.874-23.327-66.206-23.561l0.866-1.265 c0.329,0.233,33.312,23.27,65.341,23.286L331.154,751.242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M343.853,795.071c-45.287-0.426-67.794-19.456-68.016-19.649l0.984-1.172 c0.219,0.189,22.352,18.86,67.045,19.28L343.853,795.071z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M366.644,847.293c-46.926,3.449-86.816-34.307-87.214-34.69l1.042-1.118 c0.392,0.377,39.813,37.671,86.062,34.271L366.644,847.293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M381.552,899.915c-56.773,5.556-100.458-40.188-100.891-40.65l1.097-1.063 c0.43,0.457,43.622,45.663,99.649,40.181L381.552,899.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M406.668,955.323c-85.399-0.631-132.111-55.528-132.573-56.082l1.157-0.996 c0.458,0.55,46.751,54.913,131.427,55.539L406.668,955.323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M430.456,1020.115c-88.174,9.289-147.365-70.771-147.952-71.58l1.221-0.914 c0.583,0.802,59.276,80.159,146.574,70.962L430.456,1020.115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M455.723,1079.126c-45.813,6.338-84.888-15.507-109.602-34.95 c-26.74-21.036-42.893-43.88-43.053-44.107l1.235-0.893c0.635,0.905,64.508,90.419,151.214,78.425L455.723,1079.126z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M155.052,810.675c27.152-20.499,140.324,47.243,190.188,142.747 c19.817,37.955,20.979,63.716,52.654,98.4c51.513,56.405,114.81,60.946,112.927,71.82 c-2.389,13.801-108.786,32.229-199.501-15.74C174.036,1035.307,121.139,836.278,155.052,810.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.64,
      fill: "#FFFFFF"
    },
    d: "M194.69,854.981c0,0,63.01,223.226,258.054,263.848 C452.744,1118.829,283.093,1092.035,194.69,854.981z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1519.527,778.131c-13.531,0-26.253-5.302-35.946-15.009c-9.981-9.997-15.445-23.363-15.386-37.635 l0.141-33.884c0.078-18.761-14.814-34.27-33.198-34.572l-179.108-2.933l0.197-12.516l179.109,2.933 c25.067,0.411,45.374,21.558,45.267,47.141l-0.141,33.884c-0.045,10.864,4.114,21.037,11.713,28.648 c7.596,7.61,17.633,11.66,28.285,11.415l293.878-6.863l0.281,12.515l-293.878,6.863 C1520.335,778.127,1519.93,778.131,1519.527,778.131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1561.251,661.15c-14.539,0-28.672-5.74-39.236-16.043c-11.417-11.135-17.807-26.763-17.532-42.877 c0.143-8.365-2.964-16.237-8.748-22.165c-5.787-5.928-13.526-9.143-21.686-9.022l-284.719,3.836l-0.162-12.517l284.719-3.837 c0.193-0.003,0.385-0.004,0.577-0.004c11.331,0,21.951,4.5,29.963,12.711c8.147,8.349,12.523,19.435,12.321,31.216 c-0.22,12.817,4.661,24.752,13.742,33.608c9.082,8.857,20.993,13.286,33.523,12.486l155.233-9.959 c20.156-1.293,35.778-19.092,34.825-39.677l-2.069-44.673c-1.329-28.709,20.458-53.564,48.564-55.407l168.513-11.049l0.787,12.492 l-168.513,11.049c-21.47,1.408-38.111,20.395-37.097,42.324l2.068,44.673c1.268,27.374-19.506,51.043-46.309,52.762 l-155.232,9.959C1563.605,661.113,1562.426,661.15,1561.251,661.15z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#7D97F4"
    },
    cx: 1972.43,
    cy: 451.231,
    rx: 133.891,
    ry: 136.631
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.93,
      fill: "#FFFFFF"
    },
    cx: 1973.009,
    cy: 450.915,
    rx: 119.474,
    ry: 121.919
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018957890980107354370000008591695951891851440_",
    gradientUnits: "userSpaceOnUse",
    x1: 2007.424,
    y1: 251.4784,
    x2: 1966.7573,
    y2: 471.4786
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018957890980107354370000008591695951891851440_)"
    },
    d: "M2068.843,502.267 c0,1.937-1.555,3.522-3.455,3.522h-186.845c-1.9,0-3.455-1.585-3.455-3.522l-1.555-109.572c0-1.937,2.237-5.72,6.336-5.435 l182.605-4.822c2.384-0.063,4.69,0.874,6.378,2.591s2.612,4.066,2.556,6.497L2068.843,502.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2065.432,498.887c0,1.835-1.471,3.336-3.269,3.336h-179.114c-1.798,0-3.269-1.501-3.269-3.336 l-1.467-99.47c0.173-5.986,5.316-8.137,8.433-8.01l175.016-4.792c1.675-0.046,3.295,0.612,4.481,1.82 c1.186,1.208,1.834,2.86,1.792,4.57L2065.432,498.887z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1881.716,451.457c-0.168,0-0.306-0.138-0.308-0.31l-0.116-8.067 c-0.002-0.174,0.134-0.317,0.304-0.319c0.165-0.009,0.311,0.136,0.313,0.31l0.116,8.067c0.003,0.174-0.134,0.317-0.304,0.319 C1881.719,451.457,1881.717,451.457,1881.716,451.457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1881.431,431.69c-0.168,0-0.306-0.138-0.308-0.31l-0.445-30.896 c0.009-2.077,0.637-3.736,1.865-4.938c2.232-2.182,5.722-2.073,5.87-2.067l55.886-1.53c0.169-0.016,0.312,0.132,0.317,0.306 c0.005,0.174-0.13,0.318-0.3,0.323l-55.904,1.53c-0.159-0.006-3.396-0.108-5.441,1.892c-1.103,1.079-1.667,2.586-1.675,4.48 l0.445,30.89c0.002,0.174-0.134,0.317-0.304,0.319C1881.434,431.69,1881.433,431.69,1881.431,431.69z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1887.671,493.369c0.188-8.221,0.118-81.023-0.345-87.311 c-0.462-6.287,9.134-7.467,23.866-8.174c14.733-0.708,139.039-3.509,142.24-3.774c7.194-0.595,8.683,10.378,7.964,34.2 c-0.541,17.897-1.437,47.38-1.849,60.938c-0.123,4.037-3.356,7.24-7.314,7.251c-29.913,0.084-144.562,0.419-152.194,0.651 C1891.256,497.418,1887.597,496.629,1887.671,493.369z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183943996461835734840000008989444010135004293_",
    gradientUnits: "userSpaceOnUse",
    x1: 1973.8593,
    y1: 320.6676,
    x2: 1973.8593,
    y2: 474.6668
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183943996461835734840000008989444010135004293_)"
    },
    d: "M2079.283,514.885h-210.848 c-2.594,0-4.717-2.166-4.717-4.814l0,0c0-2.648,2.123-4.814,4.717-4.814h210.848c2.594,0,4.717,2.166,4.717,4.814l0,0 C2084,512.719,2081.878,514.885,2079.283,514.885z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.93
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1955.176,457.893h-6.278l-2.641-14.434c-0.406-1.972-0.695-4.302-0.868-6.991l-0.148,1.394 l-0.757,5.672l-2.567,14.358h-6.278l-4.893-27.549h4.93l2.419,15.546c0.234,1.558,0.548,4.001,0.942,7.33 c0.308-3.367,0.597-5.772,0.868-7.217l2.88-15.659h5.207l2.88,15.659c0.382,2.324,0.683,4.742,0.905,7.255 c0.431-3.719,0.745-6.174,0.942-7.368l2.345-15.546h4.967L1955.176,457.893z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1963.652,457.893v-27.549h4.727v27.549H1963.652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1973.032,449.753v-4.41h9.288v4.41H1973.032z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1991.018,457.893h-4.986v-27.549h12.095v4.428h-7.109v7.65h6.629v4.428h-6.629V457.893z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2002.411,457.893v-27.549h4.727v27.549H2002.411z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#7D97F4"
    },
    cx: 1838.539,
    cy: 774.251,
    rx: 133.891,
    ry: 136.631
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.93,
      fill: "#FFFFFF"
    },
    cx: 1839.118,
    cy: 773.935,
    rx: 119.474,
    ry: 121.919
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1818.069,715.812h-71.913v-12.757h61.413c5.799,0,10.5,4.701,10.5,10.5V715.812z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047777775786111773350000006390131335407980463_",
    gradientUnits: "userSpaceOnUse",
    x1: 1743.5931,
    y1: 732.6693,
    x2: 1935.3021,
    y2: 732.6693
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1743.593,
    y: 712.623,
    style: {
      fill: "url(#SVGID_00000047777775786111773350000006390131335407980463_)"
    },
    width: 191.709,
    height: 40.093
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1824.022,
    y: 712.623,
    style: {
      fill: "#BDD0FB"
    },
    width: 111.28,
    height: 40.093
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1837.118,
    y: 712.623,
    style: {
      fill: "#7D97F4"
    },
    width: 92.27,
    height: 40.093
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1818.069,802.984h-71.913v-12.757h61.413c5.799,0,10.5,4.701,10.5,10.5V802.984z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008867761479435535830000007150003519973885572_",
    gradientUnits: "userSpaceOnUse",
    x1: 1743.5931,
    y1: 819.8412,
    x2: 1935.3021,
    y2: 819.8412
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1743.593,
    y: 799.795,
    style: {
      fill: "url(#SVGID_00000008867761479435535830000007150003519973885572_)"
    },
    width: 191.709,
    height: 40.093
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1824.022,
    y: 799.795,
    style: {
      fill: "#BDD0FB"
    },
    width: 111.28,
    height: 40.093
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1837.118,
    y: 799.795,
    style: {
      fill: "#7D97F4"
    },
    width: 92.27,
    height: 40.093
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038373828930511722030000017892936190556984229_",
    gradientUnits: "userSpaceOnUse",
    x1: 1808.6608,
    y1: 613.6912,
    x2: 1698.3818,
    y2: 882.5537
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000038373828930511722030000017892936190556984229_)"
    },
    d: "M1746.222,842.318h-0.132 c-1.872,0-3.389-1.517-3.389-3.389V693.232c0-1.872,1.517-3.389,3.389-3.389h0.132c1.872,0,3.389,1.517,3.389,3.389v145.697 C1749.611,840.8,1748.094,842.318,1746.222,842.318z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066478299399169297970000010063577503189779614_",
    gradientUnits: "userSpaceOnUse",
    x1: 1967.7296,
    y1: 680.1428,
    x2: 1857.4507,
    y2: 949.0054
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066478299399169297970000010063577503189779614_)"
    },
    d: "M1932.547,842.318h-0.132 c-1.872,0-3.389-1.517-3.389-3.389V693.232c0-1.872,1.517-3.389,3.389-3.389h0.132c1.872,0,3.389,1.517,3.389,3.389v145.697 C1935.936,840.8,1934.419,842.318,1932.547,842.318z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000077282838452042726870000006056246970780929191_",
    gradientUnits: "userSpaceOnUse",
    x1: 1890.8981,
    y1: 677.1951,
    x2: 1894.5314,
    y2: 853.4101
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1879.662,
    y: 719.609,
    style: {
      fill: "url(#SVGID_00000077282838452042726870000006056246970780929191_)"
    },
    width: 24.277,
    height: 2.734
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008843118218070895190000012038691103957643432_",
    gradientUnits: "userSpaceOnUse",
    x1: 1890.7604,
    y1: 677.2448,
    x2: 1894.3937,
    y2: 853.4598
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1879.83,
    y: 734.492,
    style: {
      fill: "url(#SVGID_00000008843118218070895190000012038691103957643432_)"
    },
    width: 24.277,
    height: 2.734
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120550250000503487630000000820116955563712926_",
    gradientUnits: "userSpaceOnUse",
    x1: 1891.865,
    y1: 677.2705,
    x2: 1895.4984,
    y2: 853.4855
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1881.254,
    y: 749.982,
    style: {
      fill: "url(#SVGID_00000120550250000503487630000000820116955563712926_)"
    },
    width: 24.277,
    height: 2.734
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052083240697298937260000011126723175537119673_",
    gradientUnits: "userSpaceOnUse",
    x1: 1890.6555,
    y1: 677.3443,
    x2: 1894.2888,
    y2: 853.5594
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1880.361,
    y: 765.411,
    style: {
      fill: "url(#SVGID_00000052083240697298937260000011126723175537119673_)"
    },
    width: 24.277,
    height: 2.734
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065068022448210609020000002614698758721128633_",
    gradientUnits: "userSpaceOnUse",
    x1: 1890.5178,
    y1: 677.3943,
    x2: 1894.1511,
    y2: 853.6094
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1880.529,
    y: 780.294,
    style: {
      fill: "url(#SVGID_00000065068022448210609020000002614698758721128633_)"
    },
    width: 24.277,
    height: 2.734
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133516785205258733530000000963613277635317653_",
    gradientUnits: "userSpaceOnUse",
    x1: 1891.6224,
    y1: 677.42,
    x2: 1895.2559,
    y2: 853.6352
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1881.953,
    y: 795.785,
    style: {
      fill: "url(#SVGID_00000133516785205258733530000000963613277635317653_)"
    },
    width: 24.277,
    height: 2.734
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013880933945586837760000017220334158181059760_",
    gradientUnits: "userSpaceOnUse",
    x1: 1890.1183,
    y1: 677.4958,
    x2: 1893.7517,
    y2: 853.7109
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1880.736,
    y: 809.818,
    style: {
      fill: "url(#SVGID_00000013880933945586837760000017220334158181059760_)"
    },
    width: 24.277,
    height: 2.734
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029034210480560473630000018352478541117340802_",
    gradientUnits: "userSpaceOnUse",
    x1: 1891.2042,
    y1: 677.5201,
    x2: 1894.8376,
    y2: 853.7405
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1882.16,
    y: 826.22,
    style: {
      fill: "url(#SVGID_00000029034210480560473630000018352478541117340802_)"
    },
    width: 24.277,
    height: 2.734
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082355542238512132220000017846753823030180993_",
    gradientUnits: "userSpaceOnUse",
    x1: 1878.6909,
    y1: 677.311,
    x2: 1882.3358,
    y2: 854.0873
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000082355542238512132220000017846753823030180993_)"
    },
    d: "M1880.772,842.318h-0.097 c-1.37,0-2.481-1.111-2.481-2.482V711.915c0-1.37,1.111-2.482,2.481-2.482h0.097c1.37,0,2.481,1.111,2.481,2.482v127.921 C1883.253,841.207,1882.142,842.318,1880.772,842.318z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033344832839500768410000006345968977641770940_",
    gradientUnits: "userSpaceOnUse",
    x1: 1901.8971,
    y1: 676.8228,
    x2: 1905.542,
    y2: 853.5991
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000033344832839500768410000006345968977641770940_)"
    },
    d: "M1903.988,842.318h-0.097 c-1.37,0-2.481-1.111-2.481-2.482V711.915c0-1.37,1.111-2.482,2.481-2.482h0.097c1.37,0,2.481,1.111,2.481,2.482v127.921 C1906.469,841.207,1905.358,842.318,1903.988,842.318z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1441.161,505.267h-250.165v-12.518h250.165c8.492,0,16.37-3.479,22.182-9.795 c5.813-6.315,8.72-14.556,8.188-23.203l-4.214-68.492c-0.902-14.665,3.9-28.763,13.521-39.696 c9.62-10.932,22.84-17.314,37.224-17.971l126.678-5.783l0.549,12.506l-126.678,5.783c-11.07,0.505-21.243,5.417-28.646,13.829 c-7.403,8.414-11.097,19.262-10.404,30.548l4.214,68.492c0.747,12.133-3.333,23.696-11.489,32.558 C1464.13,500.386,1453.075,505.267,1441.161,505.267z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#7D97F4"
    },
    cx: 1683.273,
    cy: 259.012,
    rx: 133.891,
    ry: 136.631
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.93,
      fill: "#FFFFFF"
    },
    cx: 1683.853,
    cy: 258.696,
    rx: 119.474,
    ry: 121.919
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1666.099,176.419h-2.078c-6.742,0-12.208,5.577-12.208,12.458v0.265v33.928h14.286v-28.892 c0-2.781,2.209-5.036,4.935-5.036h35.951c3.215,0,5.821,2.659,5.821,5.94l0.25,181.861c5.555-1.189,10.878-2.744,15.621-5.207 V190.324c0-7.68-6.101-13.905-13.626-13.905H1666.099z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1651.813,215.383l-24.375,23.232c-1.021,0.974-0.324,2.719,1.073,2.687l58.748-1.207 c1.148-0.024,1.725-1.426,0.937-2.279l-22.097-22.701L1651.813,215.383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1641.607,246.151l-6.044,11.289c-0.734,1.372-0.753,3.046,0.011,4.4 c2.624,4.655,8.883,4.906,12.521,0.396c1.214-1.505,1.393-3.622,0.477-5.333l-5.757-10.752 C1642.553,245.664,1641.868,245.664,1641.607,246.151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1655.219,284.341l-8.589,16.042c-1.044,1.949-1.07,4.328,0.015,6.254 c3.729,6.615,12.623,6.972,17.793,0.563c1.726-2.139,1.979-5.147,0.677-7.579l-8.181-15.279 C1656.563,283.649,1655.589,283.649,1655.219,284.341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1674.18,250.679l-8.589,16.042c-1.044,1.949-1.07,4.328,0.015,6.254 c3.729,6.615,12.623,6.972,17.793,0.563c1.726-2.139,1.979-5.147,0.677-7.579l-8.181-15.279 C1675.525,249.986,1674.55,249.986,1674.18,250.679z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1676.69,323.309l-6.578,12.286c-0.799,1.493-0.819,3.315,0.012,4.789 c2.856,5.066,9.667,5.339,13.627,0.431c1.322-1.638,1.516-3.942,0.519-5.804l-6.265-11.701 C1677.72,322.778,1676.974,322.778,1676.69,323.309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1643.603,344.741l-6.578,12.286c-0.799,1.493-0.82,3.315,0.012,4.789 c2.856,5.066,9.667,5.339,13.627,0.431c1.322-1.638,1.516-3.942,0.519-5.804l-6.265-11.701 C1644.633,344.211,1643.887,344.211,1643.603,344.741z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2187.369,744.821c-0.473,0.17-1.02,0.091-1.436-0.258c-1.493-1.25-3.059-2.44-4.653-3.54 c-0.68-0.468-0.86-1.409-0.401-2.102c0.458-0.691,1.381-0.873,2.061-0.406c1.67,1.15,3.31,2.399,4.874,3.708 c0.635,0.532,0.728,1.485,0.208,2.132C2187.844,744.575,2187.617,744.732,2187.369,744.821z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2176.598,853.446c-0.683,0.245-1.458-0.051-1.805-0.725c-0.383-0.741-0.105-1.656,0.62-2.045 c2.548-1.367,5.038-2.936,7.402-4.667c0.835-0.61,1.649-1.237,2.445-1.879c0.642-0.52,1.576-0.408,2.086,0.248 c0.51,0.656,0.402,1.608-0.24,2.127c-0.831,0.673-1.684,1.327-2.557,1.966c-2.474,1.811-5.082,3.455-7.75,4.885 C2176.733,853.393,2176.665,853.422,2176.598,853.446z M2199.933,832.17c-0.428,0.154-0.921,0.106-1.326-0.174 c-0.68-0.47-0.859-1.411-0.401-2.104c2.188-3.304,4.081-6.842,5.625-10.516c0.323-0.768,1.194-1.123,1.95-0.792 c0.754,0.331,1.103,1.222,0.779,1.99c-1.618,3.847-3.601,7.553-5.893,11.016 C2200.483,831.871,2200.222,832.067,2199.933,832.17z M2210.575,802.144c-0.2,0.072-0.418,0.101-0.644,0.077 c-0.816-0.086-1.41-0.83-1.327-1.663c0.396-3.98,0.426-8.016,0.09-11.996c-0.069-0.833,0.53-1.569,1.352-1.636 c0.817-0.07,1.536,0.547,1.607,1.382c0.352,4.167,0.32,8.394-0.095,12.563C2211.498,801.472,2211.1,801.956,2210.575,802.144z  M2206.042,770.519c-0.739,0.265-1.561-0.104-1.865-0.852c-1.496-3.685-3.348-7.254-5.504-10.61 c-0.45-0.701-0.258-1.639,0.427-2.097c0.681-0.464,1.606-0.262,2.056,0.438c2.258,3.515,4.197,7.254,5.764,11.113 c0.314,0.773-0.045,1.659-0.802,1.979C2206.093,770.501,2206.067,770.51,2206.042,770.519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2158.085,859.911c-0.074,0.027-0.153,0.049-0.234,0.063c-1.989,0.36-4.015,0.628-6.021,0.797 c-0.818,0.069-1.535-0.551-1.605-1.385c-0.068-0.832,0.538-1.562,1.355-1.634c1.915-0.161,3.848-0.417,5.747-0.762 c0.807-0.145,1.579,0.403,1.723,1.227C2159.18,858.959,2158.759,859.67,2158.085,859.911z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2106.469,846.382c-0.47,0.168-1.011,0.093-1.427-0.251c-1.566-1.291-3.097-2.677-4.548-4.12 c-0.587-0.583-0.601-1.543-0.029-2.142c0.571-0.599,1.511-0.609,2.1-0.025c1.385,1.376,2.846,2.699,4.341,3.93 c0.638,0.526,0.739,1.479,0.225,2.13C2106.95,846.132,2106.719,846.292,2106.469,846.382z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2090.399,826.749c-0.674,0.242-1.44-0.044-1.795-0.704c-1.694-3.154-3.147-6.471-4.32-9.86 c-0.172-0.495-0.337-0.993-0.496-1.491c-0.253-0.795,0.211-1.611,0.951-1.908c0.78-0.258,1.618,0.179,1.872,0.975 c0.152,0.475,0.309,0.948,0.473,1.421c1.119,3.235,2.507,6.401,4.124,9.412c0.395,0.734,0.131,1.653-0.588,2.055 C2090.549,826.689,2090.474,826.722,2090.399,826.749z M2082.543,796.344c-0.148,0.053-0.307,0.083-0.473,0.085 c-0.82,0.012-1.494-0.658-1.506-1.495c-0.059-4.112,0.256-8.253,0.934-12.311c0.138-0.823,0.905-1.375,1.713-1.234 c0.808,0.142,1.352,0.926,1.214,1.75c-0.649,3.873-0.949,7.83-0.893,11.757 C2083.542,795.562,2083.127,796.135,2082.543,796.344z M2089.461,765.732c-0.368,0.132-0.788,0.116-1.164-0.078 c-0.732-0.379-1.025-1.29-0.655-2.036c1.82-3.667,3.987-7.183,6.442-10.449c0.499-0.662,1.431-0.786,2.082-0.277 c0.651,0.51,0.774,1.46,0.275,2.124c-2.344,3.118-4.413,6.473-6.15,9.974C2090.112,765.352,2089.809,765.608,2089.461,765.732z  M2109.579,741.975c-0.61,0.219-1.312,0.011-1.705-0.554c-0.475-0.683-0.317-1.629,0.352-2.112 c3.303-2.386,6.827-4.465,10.472-6.18c0.747-0.388,1.626-0.02,1.971,0.741c0.344,0.76,0.021,1.658-0.723,2.008 c-3.481,1.639-6.846,3.625-10.002,5.904C2109.83,741.867,2109.706,741.93,2109.579,741.975z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2144.211,730.003c-0.138,0.049-0.285,0.079-0.439,0.085c-1.925,0.07-3.868,0.234-5.776,0.488 c-0.813,0.108-1.559-0.478-1.666-1.307c-0.107-0.829,0.462-1.59,1.278-1.698c1.998-0.265,4.034-0.438,6.052-0.512 c0.819-0.03,1.509,0.623,1.539,1.459C2145.224,729.199,2144.807,729.789,2144.211,730.003z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2150.523,743.91c-0.323-0.065-0.65,0.085-0.815,0.375l-4.708,8.262 c-4.375,0.153-8.757,1.018-12.972,2.635l-7.473-5.778c-0.262-0.203-0.621-0.214-0.894-0.027l-9.336,6.378 c-0.273,0.187-0.399,0.529-0.315,0.853l2.402,9.243c-3.07,3.36-5.521,7.162-7.323,11.23l-9.286,1.299 c-0.325,0.046-0.586,0.297-0.65,0.626l-2.169,11.253c-0.063,0.329,0.085,0.663,0.369,0.832l8.107,4.818 c0.157,4.464,1.014,8.936,2.606,13.239l-5.651,7.614c-0.198,0.267-0.208,0.633-0.025,0.912l6.269,9.536 c0.183,0.279,0.519,0.408,0.837,0.323l9.056-2.434c3.299,3.137,7.03,5.645,11.021,7.49l1.289,9.476 c0.045,0.332,0.292,0.599,0.615,0.664l11.034,2.233c0.323,0.065,0.65-0.085,0.815-0.375l4.708-8.262 c4.375-0.153,8.758-1.019,12.972-2.635l7.473,5.779c0.262,0.203,0.621,0.214,0.894,0.027l9.337-6.378 c0.273-0.186,0.399-0.529,0.315-0.853l-2.402-9.243c3.07-3.359,5.521-7.162,7.323-11.23l9.286-1.298 c0.326-0.045,0.587-0.297,0.65-0.626l2.169-11.253c0.063-0.329-0.085-0.663-0.369-0.832l-8.107-4.818 c-0.158-4.464-1.014-8.936-2.606-13.239l5.651-7.614c0.198-0.267,0.208-0.633,0.025-0.912l-6.269-9.536 c-0.183-0.279-0.519-0.409-0.837-0.323l-9.056,2.434c-3.299-3.137-7.03-5.644-11.021-7.49l-1.289-9.476 c-0.045-0.332-0.292-0.599-0.614-0.664L2150.523,743.91z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2150.601,806.18c-4.083,1.464-8.811,0.666-12.25-2.494 c-5.008-4.601-5.419-12.495-0.919-17.596l0.001,0c4.502-5.1,12.24-5.505,17.247-0.905c5.008,4.601,5.419,12.495,0.919,17.597 C2154.188,804.376,2152.462,805.512,2150.601,806.18z M2140.746,789.133c-2.86,3.24-2.599,8.256,0.583,11.179 c3.182,2.922,8.096,2.666,10.957-0.576c2.86-3.24,2.598-8.255-0.583-11.179 C2148.522,785.636,2143.606,785.891,2140.746,789.133L2140.746,789.133z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2156.224,822.967c-4.891,1.755-10.175,2.148-15.399,1.091 c-7.696-1.558-14.342-6.077-18.713-12.727c-1.405-2.136-2.521-4.411-3.338-6.775c-1.727-4.992-2.122-10.381-1.095-15.708 c1.513-7.849,5.932-14.621,12.443-19.07c1.739-1.188,3.599-2.186,5.528-2.965l1.646,4.225c-1.635,0.66-3.214,1.507-4.691,2.516 c-5.283,3.61-8.943,9.022-10.375,15.312c-0.021,0.094-0.042,0.188-0.063,0.283c-0.042,0.194-0.082,0.387-0.12,0.583 c-0.87,4.519-0.536,9.091,0.93,13.326c0.693,2.004,1.64,3.934,2.831,5.746c3.709,5.643,9.347,9.477,15.875,10.797 c6.53,1.323,13.168-0.025,18.689-3.803c5.524-3.773,9.273-9.518,10.556-16.175c0.871-4.519,0.536-9.091-0.93-13.326 c-0.693-2.004-1.64-3.934-2.831-5.746c-2.518-3.83-5.996-6.888-10.059-8.844l1.895-4.108 c4.793,2.307,8.893,5.911,11.861,10.425c1.405,2.136,2.52,4.411,3.338,6.775c1.727,4.992,2.122,10.381,1.094,15.708 c-1.512,7.849-5.932,14.621-12.443,19.07C2160.765,821.003,2158.538,822.137,2156.224,822.967z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2259.943,842.384c-0.357,0.128-0.77,0.069-1.085-0.195c-1.128-0.944-2.311-1.844-3.515-2.674 c-0.513-0.354-0.649-1.065-0.303-1.588c0.346-0.522,1.043-0.66,1.556-0.307c1.261,0.869,2.501,1.812,3.682,2.801 c0.48,0.402,0.55,1.122,0.157,1.611C2260.301,842.199,2260.13,842.317,2259.943,842.384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2251.806,924.442c-0.516,0.185-1.101-0.039-1.364-0.548c-0.29-0.56-0.079-1.251,0.469-1.545 c1.925-1.033,3.806-2.218,5.592-3.525c0.631-0.461,1.246-0.935,1.847-1.419c0.485-0.393,1.19-0.308,1.576,0.188 c0.385,0.496,0.304,1.215-0.182,1.607c-0.628,0.508-1.272,1.002-1.931,1.485c-1.869,1.368-3.839,2.61-5.854,3.69 C2251.908,924.401,2251.857,924.423,2251.806,924.442z M2269.434,908.369c-0.324,0.116-0.696,0.08-1.001-0.132 c-0.514-0.355-0.649-1.066-0.303-1.589c1.653-2.496,3.083-5.168,4.25-7.944c0.244-0.58,0.902-0.848,1.473-0.598 c0.569,0.25,0.833,0.923,0.589,1.504c-1.222,2.906-2.72,5.706-4.452,8.322C2269.85,908.143,2269.652,908.291,2269.434,908.369z  M2277.473,885.687c-0.151,0.054-0.316,0.076-0.487,0.058c-0.616-0.065-1.065-0.627-1.002-1.256 c0.299-3.007,0.322-6.056,0.068-9.062c-0.053-0.629,0.4-1.185,1.021-1.236c0.617-0.053,1.16,0.414,1.214,1.044 c0.266,3.148,0.241,6.341-0.072,9.49C2278.17,885.18,2277.869,885.545,2277.473,885.687z M2274.049,861.797 c-0.558,0.2-1.179-0.078-1.408-0.643c-1.13-2.784-2.529-5.48-4.158-8.015c-0.34-0.53-0.195-1.238,0.323-1.584 c0.514-0.35,1.213-0.198,1.553,0.331c1.706,2.655,3.171,5.48,4.354,8.395c0.238,0.584-0.034,1.253-0.606,1.495 C2274.087,861.784,2274.068,861.79,2274.049,861.797z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2237.821,929.325c-0.056,0.02-0.116,0.037-0.177,0.048c-1.503,0.272-3.033,0.475-4.548,0.602 c-0.618,0.052-1.16-0.416-1.212-1.047c-0.052-0.629,0.406-1.18,1.023-1.234c1.447-0.122,2.907-0.315,4.342-0.575 c0.61-0.11,1.193,0.305,1.302,0.927C2238.649,928.606,2238.33,929.143,2237.821,929.325z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2198.829,919.105c-0.354,0.127-0.763,0.07-1.078-0.189c-1.183-0.975-2.339-2.022-3.436-3.112 c-0.444-0.441-0.454-1.166-0.022-1.618c0.432-0.452,1.142-0.46,1.586-0.019c1.046,1.04,2.15,2.039,3.279,2.969 c0.482,0.397,0.558,1.117,0.17,1.609C2199.193,918.916,2199.019,919.037,2198.829,919.105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2186.691,904.274c-0.509,0.182-1.088-0.033-1.356-0.532c-1.279-2.383-2.377-4.889-3.263-7.448 c-0.13-0.374-0.255-0.75-0.375-1.126c-0.192-0.601,0.159-1.217,0.719-1.441c0.589-0.195,1.222,0.135,1.414,0.736 c0.115,0.359,0.234,0.716,0.357,1.073c0.845,2.444,1.894,4.836,3.115,7.11c0.298,0.554,0.099,1.249-0.444,1.553 C2186.803,904.229,2186.747,904.254,2186.691,904.274z M2180.756,881.306c-0.112,0.04-0.232,0.063-0.357,0.064 c-0.619,0.009-1.128-0.497-1.138-1.129c-0.044-3.106,0.194-6.235,0.706-9.3c0.105-0.622,0.684-1.039,1.294-0.932 c0.611,0.107,1.021,0.699,0.917,1.322c-0.49,2.926-0.717,5.915-0.674,8.881 C2181.511,880.715,2181.198,881.147,2180.756,881.306z M2185.982,858.181c-0.278,0.1-0.595,0.088-0.879-0.059 c-0.553-0.286-0.774-0.975-0.495-1.538c1.375-2.77,3.012-5.426,4.866-7.893c0.376-0.5,1.081-0.594,1.572-0.21 c0.492,0.385,0.585,1.103,0.208,1.605c-1.77,2.355-3.333,4.89-4.646,7.535C2186.474,857.893,2186.245,858.087,2185.982,858.181 z M2201.179,840.235c-0.46,0.165-0.991,0.008-1.288-0.419c-0.358-0.516-0.24-1.231,0.266-1.595 c2.495-1.802,5.157-3.373,7.911-4.668c0.564-0.294,1.228-0.015,1.489,0.56c0.26,0.574,0.016,1.253-0.547,1.517 c-2.63,1.238-5.172,2.738-7.556,4.46C2201.369,840.153,2201.275,840.2,2201.179,840.235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2227.34,831.191c-0.104,0.037-0.216,0.059-0.332,0.064c-1.454,0.053-2.922,0.177-4.363,0.369 c-0.614,0.081-1.178-0.361-1.259-0.987c-0.081-0.626,0.349-1.201,0.966-1.282c1.51-0.2,3.048-0.331,4.572-0.387 c0.619-0.023,1.14,0.471,1.163,1.102C2228.106,830.583,2227.791,831.029,2227.34,831.191z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2232.109,841.696c-0.244-0.049-0.491,0.064-0.615,0.283l-3.557,6.241 c-3.305,0.115-6.615,0.769-9.799,1.991l-5.645-4.365c-0.198-0.153-0.469-0.161-0.676-0.021l-7.053,4.818 c-0.206,0.141-0.302,0.4-0.238,0.645l1.814,6.982c-2.319,2.538-4.171,5.41-5.532,8.483l-7.015,0.981 c-0.246,0.034-0.443,0.224-0.491,0.472l-1.639,8.501c-0.048,0.248,0.064,0.501,0.279,0.628l6.124,3.64 c0.119,3.372,0.766,6.75,1.969,10l-4.269,5.752c-0.15,0.202-0.157,0.478-0.019,0.689l4.736,7.203 c0.138,0.211,0.392,0.308,0.632,0.244l6.841-1.839c2.492,2.37,5.311,4.264,8.325,5.658l0.974,7.158 c0.034,0.251,0.221,0.452,0.464,0.502l8.335,1.687c0.244,0.049,0.491-0.065,0.615-0.283l3.557-6.241 c3.305-0.115,6.615-0.769,9.8-1.991l5.646,4.365c0.198,0.153,0.469,0.161,0.675,0.021l7.053-4.818 c0.206-0.141,0.302-0.4,0.238-0.645l-1.814-6.982c2.319-2.538,4.17-5.41,5.531-8.483l7.015-0.981 c0.246-0.034,0.443-0.224,0.491-0.473l1.639-8.501c0.048-0.248-0.064-0.501-0.279-0.628l-6.124-3.639 c-0.119-3.372-0.766-6.75-1.969-10.001l4.269-5.752c0.15-0.202,0.157-0.478,0.019-0.689l-4.736-7.203 c-0.138-0.211-0.392-0.309-0.632-0.244l-6.841,1.839c-2.492-2.37-5.311-4.264-8.325-5.658l-0.974-7.158 c-0.034-0.251-0.22-0.452-0.464-0.502L2232.109,841.696z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2232.168,888.735c-3.084,1.106-6.656,0.503-9.254-1.884 c-3.783-3.476-4.094-9.438-0.694-13.292l0.001,0c3.401-3.852,9.246-4.159,13.028-0.684c3.783,3.476,4.094,9.438,0.694,13.293 C2234.878,887.373,2233.573,888.232,2232.168,888.735z M2224.723,875.858c-2.161,2.448-1.963,6.236,0.44,8.445 c2.404,2.207,6.116,2.014,8.277-0.435c2.16-2.448,1.962-6.236-0.441-8.445 C2230.597,873.216,2226.884,873.409,2224.723,875.858L2224.723,875.858z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2236.415,901.417c-3.695,1.326-7.686,1.623-11.633,0.824 c-5.814-1.177-10.834-4.591-14.136-9.614c-1.061-1.614-1.904-3.332-2.522-5.118c-1.304-3.771-1.603-7.842-0.827-11.866 c1.143-5.929,4.481-11.045,9.4-14.406c1.313-0.897,2.718-1.651,4.176-2.24l1.244,3.192c-1.235,0.499-2.428,1.138-3.544,1.901 c-3.991,2.727-6.755,6.816-7.837,11.567c-0.016,0.071-0.032,0.142-0.047,0.214c-0.032,0.147-0.062,0.292-0.09,0.44 c-0.658,3.414-0.405,6.867,0.702,10.067c0.523,1.514,1.239,2.972,2.138,4.34c2.802,4.263,7.061,7.159,11.993,8.156 c4.933,0.999,9.947-0.019,14.118-2.873c4.173-2.85,7.005-7.19,7.975-12.219c0.657-3.414,0.405-6.867-0.702-10.067 c-0.523-1.514-1.239-2.972-2.138-4.34c-1.902-2.893-4.53-5.204-7.598-6.681l1.431-3.103c3.62,1.742,6.718,4.465,8.96,7.875 c1.061,1.614,1.904,3.332,2.522,5.118c1.304,3.771,1.603,7.842,0.827,11.866c-1.143,5.929-4.481,11.045-9.4,14.406 C2239.846,899.933,2238.163,900.79,2236.415,901.417z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176022420511489490050000006767436366637626254_",
    gradientUnits: "userSpaceOnUse",
    x1: 590.0472,
    y1: 199.5955,
    x2: 582.0472,
    y2: 455.5958
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176022420511489490050000006767436366637626254_)"
    },
    d: "M858.847,802.515 c-2.697,12.64-5.977,25.483-13.085,36.356c-5.711,8.749-19.995,24.515-30.749,26.333c-13.219,2.242-26.887,1.138-40.289,3.466 c-32.914,5.708-67.375,4.536-100.689,6.337c-39.323,2.124-79.146,1.852-118.552,2.226c-64.828,0.594-129.706-0.663-194.535,0.849 c-14.784,0.34-26.97-1.784-37.009-5.691c-16.948-6.592-27.719-18.263-34.445-31.65c-6.692-13.285-9.39-28.286-10.189-41.674 c-1.249-21.338,2.314-38.633,2.314-38.633c1.016-4.961,4.062-9.004,8.524-12.334c21.543-16.072,75.983-15.069,93.73-16.343 c86.271-6.235,172.742-6.745,259.18-6.218c61.615,0.374,123.53,3.364,185.129,1.648c10.388-0.289,23.491,3.449,30.05,12.096 C870.867,755.965,862.76,784.082,858.847,802.515z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145029203334328238980000008666372740759759034_",
    gradientUnits: "userSpaceOnUse",
    x1: 390.4679,
    y1: 812.5751,
    x2: 420.2039,
    y2: 812.5751
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145029203334328238980000008666372740759759034_)"
    },
    d: "M420.199,890.401 c0.193,7.196-5.368,13.19-12.42,13.386l0,0c-7.052,0.197-12.925-5.478-13.118-12.674l-4.188-156.363 c-0.193-7.197,5.368-13.19,12.42-13.386l0,0c7.052-0.197,12.925,5.478,13.118,12.674L420.199,890.401z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168116756055134681340000001456010150489083791_",
    gradientUnits: "userSpaceOnUse",
    x1: 712.0496,
    y1: 888.3161,
    x2: 709.1028,
    y2: 705.6105,
    gradientTransform: "matrix(0.9996 -0.0273 0.0273 0.9996 8.1809 2.2987)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168116756055134681340000001456010150489083791_)"
    },
    d: "M756.121,881.031 c0.193,7.197-5.368,13.19-12.42,13.387l0,0c-7.052,0.197-12.925-5.478-13.118-12.674l-4.188-156.363 c-0.193-7.196,5.368-13.19,12.42-13.386l0,0c7.052-0.197,12.925,5.478,13.118,12.674L756.121,881.031z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105389734867397017760000003726336300010624678_",
    gradientUnits: "userSpaceOnUse",
    x1: 88.6355,
    y1: 1366.2074,
    x2: 486.1175,
    y2: 1293.2006
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000105389734867397017760000003726336300010624678_)"
    },
    d: "M361.673,1198.861 c0,0-79.681-27.177-75.014,32.086c4.668,59.263-16.607,218.343,105.071,210.937 C374.02,1334.181,361.673,1198.861,361.673,1198.861z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021820142972057882600000015641255560214812311_",
    gradientUnits: "userSpaceOnUse",
    x1: 330.1517,
    y1: 1356.6124,
    x2: 333.152,
    y2: 1638.6411
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021820142972057882600000015641255560214812311_)"
    },
    d: "M372.212,1241.144 c0,0-69.498,42.062-84.771,30.451c-15.272-11.611-19.082-80.45,34.04-78.889 C374.603,1194.267,391.955,1209.164,372.212,1241.144z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016036768851766489130000003764250323516316562_",
    gradientUnits: "userSpaceOnUse",
    x1: 6015.5283,
    y1: 1418.0471,
    x2: 6011.4575,
    y2: 1165.6379,
    gradientTransform: "matrix(-0.9996 0.0273 0.0273 0.9996 6804.645 -183.767)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016036768851766489130000003764250323516316562_)"
    },
    d: "M798.916,1186.666 c0,0,78.107-31.578,76.619,27.857s28.269,217.091-93.623,216.479C793.831,1322.472,798.916,1186.666,798.916,1186.666z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013908273699403339620000007982331551558421913_",
    gradientUnits: "userSpaceOnUse",
    x1: 5955.7949,
    y1: 1238.7209,
    x2: 6058.9849,
    y2: 1238.7209,
    gradientTransform: "matrix(-0.9996 0.0273 0.0273 0.9996 6804.645 -183.767)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013908273699403339620000007982331551558421913_)"
    },
    d: "M790.656,1229.473 c0,0,71.646,38.125,86.274,25.68c14.628-12.445,14.747-81.393-38.212-76.874C785.76,1182.8,769.23,1198.641,790.656,1229.473z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114784703829406447210000008462297060682318009_",
    gradientUnits: "userSpaceOnUse",
    x1: 557.5186,
    y1: 565.8668,
    x2: 572.1192,
    y2: 764.7986
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114784703829406447210000008462297060682318009_)"
    },
    d: "M610.21,815.12l-72.075,2.01 l-3.825,58.707l19.66-28.79c1.301-1.88,3.37-3.232,5.622-3.354l30.75-1.755c2.438-0.132,4.781,0.932,6.257,2.917l20.8,27.953 l7.029-21.504L610.21,815.12z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051383775709249919370000015084618555894745744_",
    gradientUnits: "userSpaceOnUse",
    x1: 610.6206,
    y1: 875.0851,
    x2: 641.6225,
    y2: 875.0851
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000051383775709249919370000015084618555894745744_)"
    },
    d: "M636.953,848.743l-26.333-35.105 l2.975,111.076l25.116,11.817l2.893-72.896C641.817,858.268,640.171,852.995,636.953,848.743z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051384971679544704490000007013091313447940494_",
    gradientUnits: "userSpaceOnUse",
    x1: 509.9731,
    y1: 877.7894,
    x2: 541.5203,
    y2: 877.7894
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000051384971679544704490000007013091313447940494_)"
    },
    d: "M513.921,852.175l24.624-36.526 l2.975,111.076l-24.656,13.205l-6.79-72.626C509.574,861.956,510.936,856.6,513.921,852.175z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065061542390419088870000017580418765382468261_",
    gradientUnits: "userSpaceOnUse",
    x1: 528.4865,
    y1: 1733.3129,
    x2: 465.4797,
    y2: 2390.3796
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065061542390419088870000017580418765382468261_)"
    },
    d: "M792.341,911.116 c-1.135-42.364-108.864-39.803-177.334-33.88c-25.418,2.199-52.023,2.954-77.521,2.171 c-68.67-2.108-176.524,1.313-175.388,43.709c1.664,62.144-11.77,513.904,29.633,518.768c33.57,3.943,154.741-2.469,199.397-5.037 c44.73,0.075,166.072-0.276,199.38-6.085C831.589,1423.598,794.005,973.26,792.341,911.116z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034067891556690378730000015034543878528571290_",
    gradientUnits: "userSpaceOnUse",
    x1: 580.0621,
    y1: 911.4728,
    x2: 583.0623,
    y2: 1124.4944
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034067891556690378730000015034543878528571290_)"
    },
    d: "M768.818,1429.013 c0,0-300.79,19.083-355.818,9.925c-39.345-6.566-42.29-125.589-40.761-192.919c0.161-7.046,0.368-13.512,0.581-19.235 c0.575-14.882,9.635-26.609,20.926-27.185c166.376-8.292,318.852-10.037,372.559-10.391 c11.548-0.081,21.308,11.503,22.415,26.679c0.647,8.829,1.43,19.3,2.25,30.612l0.015,0.02 c3.357,45.787,7.659,105.27,8.803,124.116C801.727,1402.677,768.818,1429.013,768.818,1429.013z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033360669846918193550000018105587740344314538_",
    gradientUnits: "userSpaceOnUse",
    x1: 567.4772,
    y1: 1435.8938,
    x2: 548.4062,
    y2: 1697.4424
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000033360669846918193550000018105587740344314538_)"
    },
    d: "M791.08,1246.494l-15.41-20.817 c-4.365-6.157-10.472-8.597-16.812-8.42l-363.193,10.13c-6.067,0.169-11.814,2.638-15.84,8.589l-7.464,10.53 c0.161-7.046,0.362-13.757,0.574-19.48c0.575-14.882,9.632-26.732,20.923-27.308c166.376-8.292,318.85-10.098,372.558-10.453 c11.548-0.082,21.307,11.472,22.414,26.648C789.478,1224.742,790.26,1235.182,791.08,1246.494z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M361.357,891.039c0,0-23.479,179.872,41.015,190.11c64.494,10.238,380.904,13.331,389.39-10.861 c8.486-24.192,25.732-189.438-19.678-200.806C726.674,858.113,364.742,850.801,361.357,891.039z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040561336208399071610000010224688167056673975_",
    gradientUnits: "userSpaceOnUse",
    x1: 383.2976,
    y1: 706.6219,
    x2: 394.2684,
    y2: 863.8695,
    gradientTransform: "matrix(0.9996 -0.0273 0.0273 0.9996 8.1809 2.2987)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000040561336208399071610000010224688167056673975_)"
    },
    d: "M463.859,1125.909 c0.311,11.625-8.671,21.307-20.063,21.624l0,0c-11.392,0.318-20.879-8.849-21.191-20.474l-6.873-256.596 c-0.311-11.625,8.671-21.306,20.063-21.624l0,0c11.392-0.318,20.879,8.849,21.191,20.474L463.859,1125.909z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142168730202989941380000011121934179717481122_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.3911,
    y1: 885.6132,
    x2: 404.7059,
    y2: 1110.4133,
    gradientTransform: "matrix(0.9996 -0.0273 0.0273 0.9996 8.1809 2.2987)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142168730202989941380000011121934179717481122_)"
    },
    d: "M460.204,1050.804h-0.002 c-0.222,0-0.598,1.092-0.853,1.088l-39.948-0.025c-9.105-0.13-16.912-6.901-18.13-16.11l-3.065-22.925 c-0.684-5.163,0.769-10.372,3.992-14.411c3.227-4.041,7.994-6.529,13.088-6.89l46.799-3.291 c5.561-0.396,11.07,1.832,14.872,6.019c3.832,4.217,5.562,9.902,4.748,15.591l-3.757,25.851 C476.644,1044.828,469.153,1050.804,460.204,1050.804z M463.126,998.245l-0.364,0.018l-46.8,3.307 c-2.393,0.169-4.635,1.354-6.151,3.252c-1.514,1.897-2.2,4.378-1.88,6.805l3.054,23.059c0.573,4.328,4.232,7.635,8.511,7.696 l40.269,0.564l0,0c4.24-0.118,7.762-3.316,8.374-7.605l3.842-26.932c0.382-2.673-0.431-5.342-2.231-7.324 C468.046,999.211,465.631,998.175,463.126,998.245z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145036952344955138120000014371725089674948261_",
    gradientUnits: "userSpaceOnUse",
    x1: 6188.272,
    y1: 294.8329,
    x2: 6199.2437,
    y2: 452.094,
    gradientTransform: "matrix(-0.9996 0.0273 0.0273 0.9996 6920.854 -186.9433)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145036952344955138120000014371725089674948261_)"
    },
    d: "M730.047,861.697 c-0.311-11.625-9.799-20.791-21.191-20.474l0,0c-11.392,0.318-20.374,9.999-20.063,21.624l6.873,256.596 c0.312,11.625,9.799,20.791,21.191,20.474l0,0c11.392-0.318,20.374-9.999,20.063-21.624L730.047,861.697z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039854102088850957020000012609882107198537407_",
    gradientUnits: "userSpaceOnUse",
    x1: 6237.3076,
    y1: 885.5563,
    x2: 6238.6255,
    y2: 1110.8809,
    gradientTransform: "matrix(-0.9996 0.0273 0.0273 0.9996 6920.854 -186.9433)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039854102088850957020000012609882107198537407_)"
    },
    d: "M676.816,1030.202l-5.343-26.157 c-1.117-5.635,0.274-11.144,3.875-15.568c3.572-4.392,8.939-6.786,14.513-6.7l46.899,0.759 c5.105,0.076,9.999,2.361,13.437,6.216c3.434,3.854,5.17,9.057,4.764,14.251l-1.816,23.204 c-0.723,9.263-8.121,16.732-17.206,17.37l-39.686,1.752c-0.255,0.018-0.415-1.001-0.637-1.001h-0.002 C686.111,1045.946,678.605,1039.241,676.816,1030.202z M682.873,995.142c-1.691,2.079-2.36,4.789-1.836,7.437l5.278,26.677 c0.841,4.248,4.529,7.245,8.769,7.127l0,0l40.178-2.807c4.269-0.299,7.746-3.806,8.087-8.159l1.815-23.195 c0.19-2.44-0.628-4.88-2.241-6.69c-1.615-1.811-3.917-2.87-6.315-2.905l-46.907-0.694l-0.365,0.002 C686.831,992.005,684.476,993.174,682.873,995.142z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M391.305,1390.886c-0.856,0-1.562-0.461-1.585-1.34l-3.705-138.205 c-0.024-0.894,0.667-1.58,1.543-1.604c0.89-0.011,1.606,0.709,1.63,1.604l3.704,138.102c0.024,0.894-0.666,1.443-1.543,1.443 C391.335,1390.886,391.32,1390.886,391.305,1390.886z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M770.445,1381.17c-0.856,0-1.562-0.891-1.585-1.77l-3.705-138.418 c-0.024-0.894,0.666-1.687,1.543-1.712c0.897-0.055,1.606,0.656,1.63,1.55l3.705,138.504c0.024,0.894-0.666,1.846-1.543,1.846 C770.475,1381.17,770.46,1381.17,770.445,1381.17z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014599040496408744500000014645859758745154493_",
    gradientUnits: "userSpaceOnUse",
    x1: 823.0798,
    y1: 1251.4095,
    x2: 833.5612,
    y2: 1251.4095,
    gradientTransform: "matrix(0.9996 -0.0273 0.0273 0.9996 8.1809 2.2987)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#18459F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2874B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000014599040496408744500000014645859758745154493_)"
    },
    d: "M875.572,1230.448 c0.109,4.06-2.148,7.416-5.042,7.497s-5.327-3.145-5.436-7.204c-0.109-4.06,2.149-7.416,5.042-7.497 C873.03,1223.163,875.463,1226.389,875.572,1230.448z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054255350406016816810000009841782463747517854_",
    gradientUnits: "userSpaceOnUse",
    x1: 533.8584,
    y1: 604.4317,
    x2: 179.208,
    y2: 926.0914
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054255350406016816810000009841782463747517854_)"
    },
    d: "M323.939,872.39 c-16.948-6.592-27.719-18.263-34.445-31.65c-4.279-12.572-7.658-27.114-10.189-41.674c-1.249-21.338,2.314-38.633,2.314-38.633 c1.016-4.961,4.062-9.004,8.524-12.334C308.406,797.061,320.409,854.433,323.939,872.39z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096765221140487153160000009924954550610943385_",
    gradientUnits: "userSpaceOnUse",
    x1: 2041.0625,
    y1: 1036.7377,
    x2: 2080.6289,
    y2: 915.9561
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096765221140487153160000009924954550610943385_)"
    },
    d: "M1965.506,1003.01l6.134-56.537 c1.396-12.866,11.206-22.244,22.378-21.392l79.221,6.039c12.816,0.977,22.667,13.523,22.294,28.391l-5.716,227.656 c-0.384,15.298-10.261,28.033-23.354,30.11l-82.094,13.022L1965.506,1003.01z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009579658806372563800000002037433335309396660_",
    gradientUnits: "userSpaceOnUse",
    x1: 2024.9124,
    y1: 849.4417,
    x2: 2025.6077,
    y2: 907.8427
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000009579658806372563800000002037433335309396660_)"
    },
    d: "M1955.205,1011.588h132.015 c6.326,0,11.378-5.376,11.114-11.826l-1.892-46.135c-0.512-12.487-10.104-22.606-22.318-23.541l-108.618-8.322 L1955.205,1011.588z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128459584087770585140000004634131602373061772_",
    gradientUnits: "userSpaceOnUse",
    x1: 2054.741,
    y1: 1182.4099,
    x2: 2118.5544,
    y2: 1182.4099,
    gradientTransform: "matrix(-0.9999 0.0161 0.0161 0.9999 4119.3433 -45.9411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000128459584087770585140000004634131602373061772_)"
    },
    d: "M2060.347,1136.245 c6.657,7.021,16.391,13.023,23.233,16.753c-9.925,12.94-23.427,25.958-41.37,38.777l-5.004,11.974l-16.956-20.072 C2020.25,1183.677,2049.86,1168.028,2060.347,1136.245z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072996697136916300730000006278939701677315466_",
    gradientUnits: "userSpaceOnUse",
    x1: 2119.0098,
    y1: 1517.3982,
    x2: 2166.8555,
    y2: 1517.3982,
    gradientTransform: "matrix(-0.9999 0.0161 0.0161 0.9999 4119.3433 -45.9411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072996697136916300730000006278939701677315466_)"
    },
    d: "M1977.416,1523.584 c-0.011-0.364,0.007-0.732,0.092-1.105c5.044-21.887,31.571-35.904,31.571-35.904l10.61,0.673 c6.396,19.113,5.799,30.909,4.903,36.173c-0.024,0.147-0.066,0.288-0.102,0.431 C2015.762,1524.794,1997.778,1525.611,1977.416,1523.584z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105415163434329230660000000446233040949094784_",
    gradientUnits: "userSpaceOnUse",
    x1: 2238.8569,
    y1: 1461.2943,
    x2: 2064.6829,
    y2: 1598.0563,
    gradientTransform: "matrix(-0.9999 0.0161 0.0161 0.9999 4119.3433 -45.9411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000105415163434329230660000000446233040949094784_)"
    },
    d: "M2024.491,1523.854 c-0.444,1.76-1.691,3.146-3.308,3.521c-12.393,2.873-32.19,1.05-40.506,0.079c-1.835-0.214-3.2-1.92-3.261-3.87 C1997.778,1525.611,2015.762,1524.794,2024.491,1523.854z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181792582075109531100000016798912614583308964_",
    gradientUnits: "userSpaceOnUse",
    x1: 2132.3728,
    y1: 1461.8472,
    x2: 2123.0544,
    y2: 1543.1707,
    gradientTransform: "matrix(-0.9999 0.0161 0.0161 0.9999 4119.3433 -45.9411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181792582075109531100000016798912614583308964_)"
    },
    d: "M2023.697,1471.073l-4.14,22.122 c-0.303,1.621-1.501,2.851-2.972,3.016c-1.801,0.203-4.367,0.346-6.955,0.001c-2.321-0.309-3.971-2.684-3.601-5.267 l2.811-19.628L2023.697,1471.073z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097497320746495791800000005188924571383411131_",
    gradientUnits: "userSpaceOnUse",
    x1: 2269.7241,
    y1: 1500.705,
    x2: 2095.5652,
    y2: 1637.455,
    gradientTransform: "matrix(-0.9999 0.0161 0.0161 0.9999 4119.3433 -45.9411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097497320746495791800000005188924571383411131_)"
    },
    d: "M1931.535,1525.161 c11.698-0.527,17.729-2.033,20.838-3.39c0.026,1.187,0.039,2.396,0.021,3.649c-0.019,1.338-0.973,2.422-2.167,2.434 l-64.266,0.633c-2.051,0.02-3.288-2.387-2.429-4.321C1891.968,1524.738,1913.452,1525.974,1931.535,1525.161z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132793954104690831260000001289413392253670557_",
    gradientUnits: "userSpaceOnUse",
    x1: 2191.864,
    y1: 1518.7214,
    x2: 2260.7336,
    y2: 1518.7214,
    gradientTransform: "matrix(-0.9999 0.0161 0.0161 0.9999 4119.3433 -45.9411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132793954104690831260000001289413392253670557_)"
    },
    d: "M1883.531,1524.166 c0.074-0.168,0.138-0.34,0.246-0.499c5.547-8.185,19.747-24.536,48.198-31.994l13.695-0.667c0,0,6.272,10.721,6.703,30.764 c-3.109,1.357-9.14,2.862-20.838,3.39C1913.452,1525.974,1891.968,1524.738,1883.531,1524.166z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165212854783939069920000016573010799945606296_",
    gradientUnits: "userSpaceOnUse",
    x1: 2206.7908,
    y1: 1470.5747,
    x2: 2197.4753,
    y2: 1551.8738,
    gradientTransform: "matrix(-0.9999 0.0161 0.0161 0.9999 4119.3433 -45.9411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165212854783939069920000016573010799945606296_)"
    },
    d: "M1947.876,1469.775 c-0.136,1.045-1.764,16.916-2.394,23.069c-0.15,1.462-1.168,2.609-2.472,2.789c-2.328,0.323-6.1,0.644-9.414,0.007 c-1.788-0.344-3.105-2.069-3.137-4.1l-0.392-24.864L1947.876,1469.775z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021099882654764389280000014143035290770378648_",
    gradientUnits: "userSpaceOnUse",
    x1: 2318.0156,
    y1: 1098.9128,
    x2: 2020.5514,
    y2: 1560.4956,
    gradientTransform: "matrix(-0.9999 0.0161 0.0161 0.9999 4119.3433 -45.9411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021099882654764389280000014143035290770378648_)"
    },
    d: "M1954.306,1180.521 c0,0-31.024,128.704-27.881,289.973c0.057,2.941,2.12,5.445,4.95,6.005c4.169,0.825,10.293,1.785,15.348,1.557 c2.698-0.122,4.922-2.201,5.333-4.925c4.196-27.806,28.322-184.46,43.073-210.071c0,0,12.164,138.97,10.118,211.206 c-0.051,1.797,1.262,3.332,3.014,3.51c2.658,0.269,6.906,0.437,12.298-0.237c2.047-0.256,3.676-1.864,3.936-3.952 c2.93-23.523,19.722-163.529,17.326-264.147c-0.135-5.674-15.185-30.107-15.185-30.107L1954.306,1180.521z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179619544429742824830000005881416778306285746_",
    gradientUnits: "userSpaceOnUse",
    x1: 1368.2151,
    y1: 1007.4422,
    x2: 1320.3402,
    y2: 1476.2153,
    gradientTransform: "matrix(-0.9999 0.0161 0.0161 0.9999 3351.6743 -33.5759)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179619544429742824830000005881416778306285746_)"
    },
    d: "M1905.897,1026.169 c5.17-9.051,10.34-18.103,15.509-27.154c40.629-30.947,102.771-16.642,126.763-13.958c7.867,0.88,15.11,4.712,20.38,10.737 c20.9,23.892,66.969,89.488,15.031,157.203c-6.842-3.73-16.576-9.731-23.233-16.752c5.597-16.961,5.737-38.522-6.968-64.748 c-0.387,2.102-0.873,4.184-1.471,6.235c-16.071,55.027-16.255,100.601-16.052,111.1c0.028,1.426-0.791,2.723-2.079,3.275 c-22.144,9.481-65.133,4.761-79.57,2.808c-2.647-0.358-4.463-2.838-4.141-5.543c6.244-52.372-31.389-137.74-41.31-159.114 C1908.043,1028.72,1907.068,1027.341,1905.897,1026.169z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128487366524657991550000017542815903478785672_",
    gradientUnits: "userSpaceOnUse",
    x1: 1993.3922,
    y1: 934.5168,
    x2: 1990.74,
    y2: 1098.2865
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000128487366524657991550000017542815903478785672_)"
    },
    d: "M2008.952,941.688l5.002,44.714 c0,0-24.569,7.994-42.73-4.64l11.981-40.91L2008.952,941.688z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071518596623749228900000004297548294222584970_",
    gradientUnits: "userSpaceOnUse",
    x1: -103.0387,
    y1: 426.9687,
    x2: -166.2056,
    y2: 510.5333,
    gradientTransform: "matrix(-0.697 -0.717 -0.717 0.697 2222.1089 528.7878)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000071518596623749228900000004297548294222584970_)"
    },
    d: "M1979.499,891.115 c-0.585,0.581-24.294,50.047-24.294,50.047l27.965,13.214l29.297-43.477C2012.467,910.899,1989.296,881.396,1979.499,891.115z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060742549085351068960000012921599160899253658_",
    gradientUnits: "userSpaceOnUse",
    x1: -150.7493,
    y1: 447.0778,
    x2: -75.9299,
    y2: 447.0778,
    gradientTransform: "matrix(-0.697 -0.717 -0.717 0.697 2222.1089 528.7878)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060742549085351068960000012921599160899253658_)"
    },
    d: "M2000.208,912.292 c0.516,1.299,0.417,2.759-0.27,3.973l-13.468,23.771c-0.204,0.361-0.449,0.687-0.744,0.977 c-1.623,1.592-7.188,6.236-11.644,0.111c-3.798-5.221-7.358-9.965-11.124-11.884c-2.199-1.121-4.868-0.153-5.94,2.104 c-2.207,4.65-6.476,14.123-9.11,23.084c-0.66,2.246,0.508,4.626,2.651,5.471c5.655,2.231,16.827,6.25,26.704,7.475 c1.622,0.202,3.214-0.522,4.156-1.884c4.146-5.997,15.835-22.757,19.848-26.97c3.728-3.914,10.744-2.577,13.91-1.704 c1.202,0.331,2.473,0.141,3.528-0.531c3.166-2.018,8.668-7.003,3.433-15.204c-1.302-2.039-0.698-4.794,1.273-6.163 c3.532-2.455,7.334-7.016,3.529-14.239c-3.852-7.312-10.534-7.864-15.068-7.223c-2.006,0.284-4.064-0.758-4.866-2.657 c-0.356-0.844-1.046-1.558-2.313-1.799c-2.389-0.454-3.987-2.65-3.558-5.091c0.736-4.185,0.047-9.596-6.54-13.151 c-12.079-6.521-22.394,4.597-24.915,13.881c-2.521,9.284,10.969,15.594,19.407,16.545 C1995.286,901.88,1998.787,908.713,2000.208,912.292z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177449725671412844310000014527726784510390431_",
    gradientUnits: "userSpaceOnUse",
    x1: 1967.1718,
    y1: 1024.9097,
    x2: 2046.996,
    y2: 858.6641
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000177449725671412844310000014527726784510390431_)"
    },
    d: "M1996.206,947.249 c0,0,5.073-15.985,11.897-15.513c6.824,0.471,12.297,7.311,3.974,15.238C2001.725,956.835,1996.206,947.249,1996.206,947.249z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002349657313638533650000013549653440314013312_",
    gradientUnits: "userSpaceOnUse",
    x1: 1982.7268,
    y1: 860.7562,
    x2: 2087.9446,
    y2: 1114.059
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000002349657313638533650000013549653440314013312_)"
    },
    d: "M2055.563,1067.365 c8.587-25.235,4.85-55.474,4.811-55.777l-2.47,0.329c0.037,0.297,3.696,29.957-4.696,54.613L2055.563,1067.365z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175282203083838131230000015213743787564584850_",
    gradientUnits: "userSpaceOnUse",
    x1: 2152.1536,
    y1: 1221.8717,
    x2: 2126.6184,
    y2: 1267.3157,
    gradientTransform: "matrix(-0.9999 0.0161 0.0161 0.9999 4119.3433 -45.9411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000175282203083838131230000015213743787564584850_)"
    },
    d: "M1996.292,1259.773 c0.553-0.009,1.054-0.397,1.189-0.972c2.57-10.831,22.905-23.022,23.11-23.144c0.594-0.353,0.797-1.132,0.45-1.739 c-0.347-0.607-1.106-0.814-1.704-0.459c-0.874,0.519-21.458,12.861-24.277,24.743c-0.162,0.682,0.249,1.37,0.918,1.535 C1996.082,1259.764,1996.188,1259.775,1996.292,1259.773z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034796197953871249720000005752328070737035958_",
    gradientUnits: "userSpaceOnUse",
    x1: 1475.1016,
    y1: 1017.7085,
    x2: 1423.7241,
    y2: 1520.7756,
    gradientTransform: "matrix(-0.9999 0.0161 0.0161 0.9999 3351.6743 -33.5759)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034796197953871249720000005752328070737035958_)"
    },
    d: "M1822.677,1041.625 c46.605,6.355,76.436-24.079,98.729-42.61c29.434-24.465,52.818-13.183,52.818-13.183l-30.816,62.442 c-46.758,46.463-95.599,37.118-126.522,22.819C1816.225,1059.142,1819.198,1049.081,1822.677,1041.625z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103233757233435547530000014910216304951052447_",
    gradientUnits: "userSpaceOnUse",
    x1: 1659.51,
    y1: 938.8918,
    x2: 1443.6447,
    y2: 1215.0725,
    gradientTransform: "matrix(-0.9999 0.0161 0.0161 0.9999 3351.6743 -33.5759)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103233757233435547530000014910216304951052447_)"
    },
    d: "M1756.885,1014.394l15.552,8.213 c18.672,11.185,35.314,16.983,50.24,19.018c-3.478,7.456-6.452,17.516-5.791,29.469c-19.686-9.102-32.112-20.211-32.112-20.211 C1749.512,1030.204,1756.885,1014.394,1756.885,1014.394z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163070458595585812140000012932225982325103252_",
    gradientUnits: "userSpaceOnUse",
    x1: 1688.0668,
    y1: 961.1232,
    x2: 1471.9193,
    y2: 1237.6649,
    gradientTransform: "matrix(-0.9999 0.0161 0.0161 0.9999 3351.6743 -33.5759)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163070458595585812140000012932225982325103252_)"
    },
    d: "M1711.814,1037.312 c0.942-3.393,3.345-6.165,6.531-7.533l31.088-13.355c0,0,0.408-4.103-6.72-6.769c-7.128-2.666-5.599-10.79-5.599-10.79 s9.749,4.346,24.029,11.258c8.167,3.953,12.827,11.093,15.323,16.484l-7.884,10.942c-19.192,6.229-38.688,7.68-58.406,5.659 L1711.814,1037.312z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154383721459431347640000015102549575021245830_",
    gradientUnits: "userSpaceOnUse",
    x1: 2035.7223,
    y1: 1059.8578,
    x2: 1981.4636,
    y2: 1331.1521
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000154383721459431347640000015102549575021245830_)"
    },
    d: "M2045.276,1129.731 c-11.513-56.09-20.663-108.489-21.566-148.008c8.217-8.82,17.005-7.547,26.352,3.612c-2.772,30.018-0.911,79.314,1.532,131.031 c0.203,4.297-1.407,8.478-4.425,11.481L2045.276,1129.731z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116953230730464804970000006903229200690521762_",
    gradientUnits: "userSpaceOnUse",
    x1: 1937.3395,
    y1: 1039.7808,
    x2: 1883.1293,
    y2: 1310.8323
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116953230730464804970000006903229200690521762_)"
    },
    d: "M1934.495,1095.2 c11.399-43.666,26.174-94.312,25.448-112.919c-6.261-6.23-14.859-3.464-25.448,6.973c3.402,14.946-1.735,55.92-5.76,93.506 L1934.495,1095.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144313207202792451550000013709154247274339985_",
    gradientUnits: "userSpaceOnUse",
    x1: 2191.9053,
    y1: 1397.312,
    x2: 2132.905,
    y2: 1520.3123
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000144313207202792451550000013709154247274339985_)"
    },
    d: "M2146.976,1523.27 c-7.195,6.701-13.033,0.124-14.989-0.708c0.079,1.316-15.717,4.605-26.693,5.89c-10.976,1.284-13.167,12.255-8.165,14.474 c5.003,2.219,21.75,2.885,30.451,0.888c7.465-1.714,13.648,1.147,20.611,1.714c2.218,0.181,4.221-1.354,4.677-3.576 C2155.026,1531.436,2146.976,1523.27,2146.976,1523.27z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098215789387622026920000003736847641397569693_",
    gradientUnits: "userSpaceOnUse",
    x1: -6357.5781,
    y1: 2028.8505,
    x2: -6443.7104,
    y2: 2131.1958,
    gradientTransform: "matrix(0.9888 0.1491 -0.1491 0.9888 8863.5781 -145.2551)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098215789387622026920000003736847641397569693_)"
    },
    d: "M2109.136,961.716 c0,0-13.36-37.025,30.813-32.792c0,0,20.341-6.318,24.034,13.568c0,0,14.592,7.177,7.057,25.857 c0,0,37.774-21.162,59.821,12.094c22.047,33.256,8.671,55.051-7.384,62.45c0,0,14.466,5.087,10.114,21.644 c-4.352,16.557-35.383,32.06-57.081,15.623c0,0-53.635,14.845-57.721-24.663c0,0-27.599-13.256-5.204-49.438 C2135.98,969.879,2109.136,961.716,2109.136,961.716z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121996658487016888510000011901919136740341929_",
    gradientUnits: "userSpaceOnUse",
    x1: 4846.4575,
    y1: 832.3347,
    x2: 4676.2139,
    y2: 1071.2251,
    gradientTransform: "matrix(-0.9922 -0.1247 -0.1247 0.9922 6904.9043 630.3192)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121996658487016888510000011901919136740341929_)"
    },
    d: "M2113.407,1040.734 c8.686-2.657,33.979-7.564,58.036,15.091c4.08,3.843,5.748,9.681,4.292,15.149c-6.462,24.276-23.51,95.997-8.562,127.029 c0,0-26.343,29.634-55.082,5.75c0,0-12.895-57.349-29.784-82.525c-11.66-17.381,18.593-65.27,26.247-76.839 C2109.715,1042.637,2111.423,1041.34,2113.407,1040.734z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178168339895932063690000013773740460207568279_",
    gradientUnits: "userSpaceOnUse",
    x1: 2137.4155,
    y1: 990,
    x2: 2137.4155,
    y2: 1173.9999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178168339895932063690000013773740460207568279_)"
    },
    d: "M2147.955,990.162 c0,0,2.282,39.424,3.249,55.783c0,0-14.198,6.588-27.577-4.532c0,0,2.345-37.268,0.316-43.9L2147.955,990.162z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008831177456985969800000010986146049188795265_",
    gradientUnits: "userSpaceOnUse",
    x1: -4503.9067,
    y1: -2180.5393,
    x2: -4535.9067,
    y2: -2111.5396,
    gradientTransform: "matrix(0.9888 0.1491 -0.1491 0.9888 8863.5781 -145.2551)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008831177456985969800000010986146049188795265_)"
    },
    d: "M2111.626,951.763 c0,0-27.045,52.122-5.32,63.209c21.725,11.087,40.985-25.96,40.985-25.96s4.302-27.09-4.94-34.813 C2133.109,946.476,2111.626,951.763,2111.626,951.763z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024681558987967723680000007291438401998824088_",
    gradientUnits: "userSpaceOnUse",
    x1: -6398.769,
    y1: 1993.9349,
    x2: -6484.4653,
    y2: 2095.7625,
    gradientTransform: "matrix(0.9888 0.1491 -0.1491 0.9888 8863.5781 -145.2551)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024681558987967723680000007291438401998824088_)"
    },
    d: "M2125.545,938.286 c0,0-14.812,5.795-16.027,13.153c-1.215,7.358,23.487,10.642,30.209,10.047l9.133,27.768c0,0,12.383-28.995,4.042-43.618 C2144.562,931.012,2125.545,938.286,2125.545,938.286z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120538004246530432820000002637169358023987350_",
    gradientUnits: "userSpaceOnUse",
    x1: -4480.8296,
    y1: -2169.8279,
    x2: -4512.8296,
    y2: -2100.8279,
    gradientTransform: "matrix(0.9888 0.1491 -0.1491 0.9888 8863.5781 -145.2551)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120538004246530432820000002637169358023987350_)"
    },
    d: "M2140.375,986.397 c0,0,10.947-17.095,17.417-7.815c6.47,9.28-9.367,19.084-15.836,14.978L2140.375,986.397z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178884679452876232670000003911173517565159072_",
    gradientUnits: "userSpaceOnUse",
    x1: 2164.6753,
    y1: 1369.4269,
    x2: 1981.6843,
    y2: 1516.4199
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178884679452876232670000003911173517565159072_)"
    },
    d: "M2167.06,1503.094 c-7.634-18.923-27.283-71.935-32.17-95.41c-5.553-26.679-34.586-48.349-34.586-48.349l44.24-69.538l-14.26-5.361l-41.279,3.829 c0,0-14.844,59.151-17.282,70.166c-0.981,4.432-0.298,9.071,1.913,13.014l84.98,144.67 C2158.934,1516.66,2168.253,1506.053,2167.06,1503.094z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168810297818562605730000001478545356810420656_",
    gradientUnits: "userSpaceOnUse",
    x1: 2259.907,
    y1: 1129.0536,
    x2: 2181.9109,
    y2: 1306.0449
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168810297818562605730000001478545356810420656_)"
    },
    d: "M2162.557,1357.96l26.268-83.481 l-58.541,9.957l-1.307,62.823c0,0,2.977,129.703,3.381,148.124c0.146,6.66,1.005,16.755-0.338,26.858 c-0.141,1.292,0.562,1.793,1.36,2.298c4.037,2.551,7.959,4.264,13.838-1.005l-1.266-4.882 c-0.375-3.255,1.241-7.137,1.964-10.711c3.905-19.314,16.951-83.556,20.51-97.391c3.827-14.877,4.375-34.291-6.597-51.432 L2162.557,1357.96z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013157397243172173800000003737728987691785389_",
    gradientUnits: "userSpaceOnUse",
    x1: 4585.4277,
    y1: 1305.6055,
    x2: 4545.1885,
    y2: 1395.306,
    gradientTransform: "matrix(-1 -0.0095 -0.0095 1 6762.6343 51.0736)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013157397243172173800000003737728987691785389_)"
    },
    d: "M2130.19,1307.412 c0,0,34.912-5.664,52.917-2.758c0.613-0.12,1.22-0.223,1.832-0.341c1.606-7.375,2.897-13.299,3.52-16.153 c8.54-39.144,18.075-81.358-23.873-106.884c-19.332,8.45-37.363,13.43-56.47,8.491c0,0,3.785,12.311-2.03,32.588 l-20.365,72.132C2097.391,1296.105,2127.939,1303.678,2130.19,1307.412z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073708806959257551130000006718075718088597669_",
    gradientUnits: "userSpaceOnUse",
    x1: 4687.0957,
    y1: 1035.525,
    x2: 4557.0464,
    y2: 1325.4268,
    gradientTransform: "matrix(-1 -0.0095 -0.0095 1 6762.6343 51.0736)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000073708806959257551130000006718075718088597669_)"
    },
    d: "M2130.19,1307.412 c0,0,34.912-5.664,52.917-2.758c0.613-0.12,1.22-0.223,1.832-0.341c1.606-7.375,2.897-13.299,3.52-16.153 c8.54-39.144,18.075-81.358-23.873-106.884c-19.332,8.45-37.363,13.43-56.47,8.491c0.341,1.879,0.833,4.916,1.166,8.69 c0.484,5.485,0.367,9.52,0.363,10.156c-0.035,4.795,4.825,14.655,25.893,36.762c-0.465,10.861-1.195,22.171-2.251,33.89 C2132.411,1288.976,2131.366,1298.363,2130.19,1307.412z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001649030495407578200000007993801474163382691_",
    gradientUnits: "userSpaceOnUse",
    x1: 5793.1943,
    y1: 1328.8771,
    x2: 6055.1426,
    y2: 1029.2465,
    gradientTransform: "matrix(-0.9941 -0.1087 -0.1087 0.9941 8126.9453 519.906)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001649030495407578200000007993801474163382691_)"
    },
    d: "M2178.165,1064.081 c0,0,41.683,34.206,52.643,81.704c10.96,47.498-59.273,53.72-59.273,53.72s-9.717-10.72-20.988-6.655 c-11.271,4.066-1.177-18.969,12.083-19.127c13.26-0.158,7.286,10.642,25.906,1.664c18.138-8.746,29.019-35.052-18.224-73.88 c-2.739-2.25-4.941-5.141-6.292-8.454C2154.597,1069.938,2161.54,1054.57,2178.165,1064.081z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070089832088153322200000011222692308540980656_",
    gradientUnits: "userSpaceOnUse",
    x1: -249.7741,
    y1: 4309.8682,
    x2: -225.7727,
    y2: 4468.8779,
    gradientTransform: "matrix(0.7069 -0.7073 0.7073 0.7069 186.6644 -1033.2131)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070089832088153322200000011222692308540980656_)"
    },
    d: "M2166.995,1502.719 c-0.422,9.484-8.717,9.069-10.588,9.854c0.925,0.834-7.563,13.944-14.122,22.378c-6.56,8.433-0.777,17.351,4.07,15.401 c4.847-1.95,16.595-13.046,21.146-20.392c3.905-6.303,9.974-8.634,15.05-13.052c1.617-1.407,1.953-3.824,0.79-5.639 C2177.836,1502.683,2166.995,1502.719,2166.995,1502.719z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045601118960112647000000002275180342640343695_",
    gradientUnits: "userSpaceOnUse",
    x1: 1875.901,
    y1: 1156.6095,
    x2: 1742.2979,
    y2: 1309.6571
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000045601118960112647000000002275180342640343695_)"
    },
    d: "M1829.275,1348.382h-40.351 c-3.373,0-6.117-2.785-6.117-6.21v-218.079c0-3.424,2.744-6.21,6.117-6.21h40.351c3.373,0,6.117,2.785,6.117,6.21v218.079 C1835.392,1345.597,1832.648,1348.382,1829.275,1348.382z M1788.924,1119.954c-2.249,0-4.078,1.857-4.078,4.14v218.079 c0,2.283,1.829,4.14,4.078,4.14h40.351c2.249,0,4.078-1.857,4.078-4.14v-218.079c0-2.283-1.829-4.14-4.078-4.14H1788.924z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083067017719583370610000010524009726400876212_",
    gradientUnits: "userSpaceOnUse",
    x1: 1825.666,
    y1: 994.366,
    x2: 1814.6659,
    y2: 1096.3658
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083067017719583370610000010524009726400876212_)"
    },
    d: "M1836.922,1165.587h-5.098V1131.2 c0-5.345-4.255-9.694-9.486-9.694h-26.477c-5.231,0-9.486,4.349-9.486,9.694v34.387h-5.098V1131.2 c0-8.199,6.542-14.869,14.583-14.869h26.477c8.041,0,14.584,6.67,14.584,14.869V1165.587z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134212809371099406900000011029843524460574368_",
    gradientUnits: "userSpaceOnUse",
    x1: 1725.3901,
    y1: 1521.5756,
    x2: 1862.3903,
    y2: 1270.5758
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134212809371099406900000011029843524460574368_)"
    },
    d: "M1862.495,1520.685h-114.74 c-2.75,0-5-2.25-5-5V1235.3c0-2.75,2.25-5,5-5h114.74c2.75,0,5,2.25,5,5v280.385 C1867.495,1518.435,1865.245,1520.685,1862.495,1520.685z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011009280227190167250000015233462568475525306_",
    gradientUnits: "userSpaceOnUse",
    x1: 1934.1818,
    y1: 1296.677,
    x2: 1674.9517,
    y2: 1593.635
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011009280227190167250000015233462568475525306_)"
    },
    d: "M1869.103,1229.623h-12.035v290.834 h12.035c6.619,0,12.035-5.526,12.035-12.281v-266.272C1881.138,1235.149,1875.722,1229.623,1869.103,1229.623z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085237364023356037510000010214648868050541483_",
    gradientUnits: "userSpaceOnUse",
    x1: 1780.475,
    y1: 1310.4281,
    x2: 1773.4751,
    y2: 1437.428
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085237364023356037510000010214648868050541483_)"
    },
    d: "M1774.362,1526.652h-9.849 c-1.925,0-3.5-1.575-3.5-3.5v-24.931c0-1.925,1.575-3.5,3.5-3.5h9.849c1.925,0,3.5,1.575,3.5,3.5v24.931 C1777.862,1525.077,1776.287,1526.652,1774.362,1526.652z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173859720195983360860000011961358968277051055_",
    gradientUnits: "userSpaceOnUse",
    x1: 1864.2412,
    y1: 1315.045,
    x2: 1857.2413,
    y2: 1442.0449
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173859720195983360860000011961358968277051055_)"
    },
    d: "M1858.382,1526.652h-9.849 c-1.925,0-3.5-1.575-3.5-3.5v-24.931c0-1.925,1.575-3.5,3.5-3.5h9.849c1.925,0,3.5,1.575,3.5,3.5v24.931 C1861.882,1525.077,1860.307,1526.652,1858.382,1526.652z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087382133418553784400000007701985894622363008_",
    gradientUnits: "userSpaceOnUse",
    x1: 1028.2092,
    y1: 1503.0212,
    x2: 1070.1996,
    y2: 123.3017
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000087382133418553784400000007701985894622363008_)"
    },
    d: "M1325.305,533.59 c-0.125-4.343-2.507-8.451-6.581-11.351c-4.074-2.899-9.479-4.331-14.93-3.956l-550.615,37.864 c-10.237,0.704-18.414,7.507-18.414,15.665v878.713c0,8.684,9.504,15.068,20.443,15.068h576.583 c5.331,0,10.437-1.378,14.164-4.405c3.726-3.027,5.759-6.954,5.637-11.185L1325.305,533.59z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132769423921521750030000003046101153821045663_",
    gradientUnits: "userSpaceOnUse",
    x1: 933.4701,
    y1: 34.283,
    x2: 900.467,
    y2: 202.2995
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000132769423921521750030000003046101153821045663_)"
    },
    d: "M827.623,610.075h-0.469 c-18.375,0-33.271,15.621-33.271,34.372v32.575h33.74V610.075z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033331650886212703530000007882340828439304357_",
    gradientUnits: "userSpaceOnUse",
    x1: 941.577,
    y1: 35.8747,
    x2: 908.5739,
    y2: 203.8914
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000033331650886212703530000007882340828439304357_)"
    },
    d: "M793.884,686.586v24.968 c0,3.345,2.657,5.636,5.936,5.636h27.804v-30.604H793.884z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103226993052198197060000009751110187893506973_",
    gradientUnits: "userSpaceOnUse",
    x1: 972.053,
    y1: 41.8615,
    x2: 939.0499,
    y2: 209.8781
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000103226993052198197060000009751110187893506973_)"
    },
    d: "M837.464,610.075h-0.469 v66.947h33.74v-32.575C870.735,625.697,855.839,610.075,837.464,610.075z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018225749117486797880000003210170019416629924_",
    gradientUnits: "userSpaceOnUse",
    x1: 982.6096,
    y1: 43.9353,
    x2: 949.6064,
    y2: 211.9518
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000018225749117486797880000003210170019416629924_)"
    },
    d: "M836.995,717.191h27.804 c3.278,0,5.936-2.291,5.936-5.636v-24.968h-33.74V717.191z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000081631332213143618540000015735620435457381281_",
    gradientUnits: "userSpaceOnUse",
    x1: 1068.8285,
    y1: 60.8712,
    x2: 1035.8253,
    y2: 228.8877
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000081631332213143618540000015735620435457381281_)"
    },
    d: "M968.204,610.075h-0.469 c-18.375,0-33.271,15.621-33.271,34.372v32.575h33.739V610.075z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020382913172207500480000008713533022405342636_",
    gradientUnits: "userSpaceOnUse",
    x1: 1076.9352,
    y1: 62.4636,
    x2: 1043.9321,
    y2: 230.4802
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000020382913172207500480000008713533022405342636_)"
    },
    d: "M934.465,686.586v24.968 c0,3.345,2.657,5.636,5.936,5.636h27.804v-30.604H934.465z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141421927390976289490000007518845152340290480_",
    gradientUnits: "userSpaceOnUse",
    x1: 1107.4115,
    y1: 68.4496,
    x2: 1074.4083,
    y2: 236.4662
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000141421927390976289490000007518845152340290480_)"
    },
    d: "M978.045,610.075h-0.469 v66.947h33.74v-32.575C1011.316,625.697,996.42,610.075,978.045,610.075z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072279538996199356750000017125879657327449241_",
    gradientUnits: "userSpaceOnUse",
    x1: 1117.9679,
    y1: 70.5241,
    x2: 1084.9647,
    y2: 238.5406
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000072279538996199356750000017125879657327449241_)"
    },
    d: "M977.576,717.191h27.804 c3.278,0,5.936-2.291,5.936-5.636v-24.968h-33.74V717.191z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103955456270363083910000007794168468343563139_",
    gradientUnits: "userSpaceOnUse",
    x1: 1204.1869,
    y1: 87.4593,
    x2: 1171.1838,
    y2: 255.4758
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000103955456270363083910000007794168468343563139_)"
    },
    d: "M1108.785,610.075 h-0.469c-18.375,0-33.271,15.621-33.271,34.372v32.575h33.739V610.075z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152981438383948551640000017827329590015925402_",
    gradientUnits: "userSpaceOnUse",
    x1: 1212.2937,
    y1: 89.0519,
    x2: 1179.2905,
    y2: 257.0686
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000152981438383948551640000017827329590015925402_)"
    },
    d: "M1075.046,686.586 v24.968c0,3.345,2.657,5.636,5.936,5.636h27.804v-30.604H1075.046z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119837063219638494560000011273314680418910593_",
    gradientUnits: "userSpaceOnUse",
    x1: 1242.7698,
    y1: 95.0383,
    x2: 1209.7666,
    y2: 263.0549
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000119837063219638494560000011273314680418910593_)"
    },
    d: "M1118.626,610.075 h-0.469v66.947h33.739v-32.575C1151.897,625.697,1137.001,610.075,1118.626,610.075z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114053505547146756920000001527526549197257129_",
    gradientUnits: "userSpaceOnUse",
    x1: 1253.326,
    y1: 97.1133,
    x2: 1220.323,
    y2: 265.1297
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000114053505547146756920000001527526549197257129_)"
    },
    d: "M1118.157,717.191 h27.804c3.278,0,5.936-2.291,5.936-5.636v-24.968h-33.739V717.191z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096028146609085856440000008913060580187057579_",
    gradientUnits: "userSpaceOnUse",
    x1: 1339.5453,
    y1: 114.0479,
    x2: 1306.5421,
    y2: 282.0644
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000096028146609085856440000008913060580187057579_)"
    },
    d: "M1249.366,610.075 h-0.469c-18.375,0-33.271,15.621-33.271,34.372v32.575h33.74V610.075z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049220525595553602600000005044726945640000421_",
    gradientUnits: "userSpaceOnUse",
    x1: 1347.652,
    y1: 115.6404,
    x2: 1314.6488,
    y2: 283.6571
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000049220525595553602600000005044726945640000421_)"
    },
    d: "M1215.627,686.586 v24.968c0,3.345,2.657,5.636,5.936,5.636h27.804v-30.604H1215.627z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034088135834562218100000004413848151656865976_",
    gradientUnits: "userSpaceOnUse",
    x1: 1378.1282,
    y1: 121.6264,
    x2: 1345.1251,
    y2: 289.6429
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000034088135834562218100000004413848151656865976_)"
    },
    d: "M1259.207,610.075 h-0.469v66.947h33.739v-32.575C1292.478,625.697,1277.582,610.075,1259.207,610.075z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129190006463577831680000001154659509093360053_",
    gradientUnits: "userSpaceOnUse",
    x1: 1388.6843,
    y1: 123.7021,
    x2: 1355.6813,
    y2: 291.7185
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000129190006463577831680000001154659509093360053_)"
    },
    d: "M1258.738,717.191 h27.804c3.278,0,5.936-2.291,5.936-5.636v-24.968h-33.739V717.191z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098928690131631008960000000141617988208422833_",
    gradientUnits: "userSpaceOnUse",
    x1: 968.9234,
    y1: 41.2443,
    x2: 935.9203,
    y2: 209.2609
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000098928690131631008960000000141617988208422833_)"
    },
    d: "M827.623,797.527h-0.469 c-18.375,0-33.271,15.621-33.271,34.372v32.575h33.74V797.527z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000099640640327956035020000001007122640950411923_",
    gradientUnits: "userSpaceOnUse",
    x1: 977.0291,
    y1: 42.842,
    x2: 944.026,
    y2: 210.8587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000099640640327956035020000001007122640950411923_)"
    },
    d: "M793.884,874.038v24.968 c0,3.345,2.657,5.636,5.936,5.636h27.804v-30.604H793.884z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079475150311604298590000007877908171289328802_",
    gradientUnits: "userSpaceOnUse",
    x1: 1007.5054,
    y1: 48.8275,
    x2: 974.5023,
    y2: 216.8441
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000079475150311604298590000007877908171289328802_)"
    },
    d: "M837.464,797.527h-0.469 v66.947h33.74v-32.575C870.735,813.148,855.839,797.527,837.464,797.527z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025401648032442888140000015035170913095879080_",
    gradientUnits: "userSpaceOnUse",
    x1: 1018.0621,
    y1: 50.9004,
    x2: 985.059,
    y2: 218.917
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000025401648032442888140000015035170913095879080_)"
    },
    d: "M836.995,904.642h27.804 c3.278,0,5.936-2.291,5.936-5.636v-24.968h-33.74V904.642z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122685382463143208720000007721065285375453076_",
    gradientUnits: "userSpaceOnUse",
    x1: 1104.2806,
    y1: 67.8383,
    x2: 1071.2776,
    y2: 235.8548
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000122685382463143208720000007721065285375453076_)"
    },
    d: "M968.204,797.527h-0.469 c-18.375,0-33.271,15.621-33.271,34.372v32.575h33.739V797.527z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171694194020785483660000017678807139704815284_",
    gradientUnits: "userSpaceOnUse",
    x1: 1112.3881,
    y1: 69.4275,
    x2: 1079.3849,
    y2: 237.4441
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000171694194020785483660000017678807139704815284_)"
    },
    d: "M934.465,874.038v24.968 c0,3.345,2.657,5.636,5.936,5.636h27.804v-30.604H934.465z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182489037507346161550000012204574075702259875_",
    gradientUnits: "userSpaceOnUse",
    x1: 1142.8647,
    y1: 75.411,
    x2: 1109.8616,
    y2: 243.4276
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000182489037507346161550000012204574075702259875_)"
    },
    d: "M978.045,797.527h-0.469 v66.947h33.74v-32.575C1011.316,813.148,996.42,797.527,978.045,797.527z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145742188820965762560000013406844173477911718_",
    gradientUnits: "userSpaceOnUse",
    x1: 1153.4204,
    y1: 77.4892,
    x2: 1120.4174,
    y2: 245.5058
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000145742188820965762560000013406844173477911718_)"
    },
    d: "M977.576,904.642h27.804 c3.278,0,5.936-2.291,5.936-5.636v-24.968h-33.74V904.642z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067230424785481604490000002316650073066903738_",
    gradientUnits: "userSpaceOnUse",
    x1: 1239.6396,
    y1: 94.4235,
    x2: 1206.6366,
    y2: 262.44
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000067230424785481604490000002316650073066903738_)"
    },
    d: "M1108.785,797.527 h-0.469c-18.375,0-33.271,15.621-33.271,34.372v32.575h33.739V797.527z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082334012412587861110000017004769802931558304_",
    gradientUnits: "userSpaceOnUse",
    x1: 1247.7465,
    y1: 96.0158,
    x2: 1214.7433,
    y2: 264.0325
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000082334012412587861110000017004769802931558304_)"
    },
    d: "M1075.046,874.038 v24.968c0,3.345,2.657,5.636,5.936,5.636h27.804v-30.604H1075.046z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039825361600957685810000012386743329770751167_",
    gradientUnits: "userSpaceOnUse",
    x1: 1278.2228,
    y1: 102.001,
    x2: 1245.2196,
    y2: 270.0176
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000039825361600957685810000012386743329770751167_)"
    },
    d: "M1118.626,797.527 h-0.469v66.947h33.739v-32.575C1151.897,813.148,1137.001,797.527,1118.626,797.527z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137092786599631008400000008644103461587449000_",
    gradientUnits: "userSpaceOnUse",
    x1: 1288.7786,
    y1: 104.0785,
    x2: 1255.7755,
    y2: 272.095
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000137092786599631008400000008644103461587449000_)"
    },
    d: "M1118.157,904.642 h27.804c3.278,0,5.936-2.291,5.936-5.636v-24.968h-33.739V904.642z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001635746081802728810000017701166675025303185_",
    gradientUnits: "userSpaceOnUse",
    x1: 1374.9982,
    y1: 121.0113,
    x2: 1341.995,
    y2: 289.0279
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000001635746081802728810000017701166675025303185_)"
    },
    d: "M1249.366,797.527 h-0.469c-18.375,0-33.271,15.621-33.271,34.372v32.575h33.74V797.527z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137830780690215044320000000634094339583592112_",
    gradientUnits: "userSpaceOnUse",
    x1: 1383.1049,
    y1: 122.6041,
    x2: 1350.1017,
    y2: 290.6209
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000137830780690215044320000000634094339583592112_)"
    },
    d: "M1215.627,874.038 v24.968c0,3.345,2.657,5.636,5.936,5.636h27.804v-30.604H1215.627z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013188237200469430530000000244045324634906559_",
    gradientUnits: "userSpaceOnUse",
    x1: 1413.5808,
    y1: 128.591,
    x2: 1380.5778,
    y2: 296.6076
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000013188237200469430530000000244045324634906559_)"
    },
    d: "M1259.207,797.527 h-0.469v66.947h33.739v-32.575C1292.478,813.148,1277.582,797.527,1259.207,797.527z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107586192411462040290000000905682408039838383_",
    gradientUnits: "userSpaceOnUse",
    x1: 1424.1376,
    y1: 130.6637,
    x2: 1391.1345,
    y2: 298.6802
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000107586192411462040290000000905682408039838383_)"
    },
    d: "M1258.738,904.642 h27.804c3.278,0,5.936-2.291,5.936-5.636v-24.968h-33.739V904.642z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040535471692529262000000016932886047805712316_",
    gradientUnits: "userSpaceOnUse",
    x1: 1004.3751,
    y1: 48.2142,
    x2: 971.3719,
    y2: 216.2307
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000040535471692529262000000016932886047805712316_)"
    },
    d: "M827.623,984.979h-0.469 c-18.375,0-33.271,15.621-33.271,34.372v32.575h33.74V984.979z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000921006196484662430000009365343705269535384_",
    gradientUnits: "userSpaceOnUse",
    x1: 1012.4825,
    y1: 49.8029,
    x2: 979.4792,
    y2: 217.8201
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000000921006196484662430000009365343705269535384_)"
    },
    d: "M793.884,1061.489 v24.968c0,3.345,2.657,5.636,5.936,5.636h27.804v-30.604H793.884z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113337611726828164020000000823526677418676648_",
    gradientUnits: "userSpaceOnUse",
    x1: 1042.9585,
    y1: 55.7902,
    x2: 1009.9553,
    y2: 223.8068
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000113337611726828164020000000823526677418676648_)"
    },
    d: "M837.464,984.979h-0.469 v66.947h33.74v-32.575C870.735,1000.6,855.839,984.979,837.464,984.979z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000030480894046065102580000014874457346501271689_",
    gradientUnits: "userSpaceOnUse",
    x1: 1053.5153,
    y1: 57.8628,
    x2: 1020.512,
    y2: 225.8798
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000030480894046065102580000014874457346501271689_)"
    },
    d: "M836.995,1092.094 h27.804c3.278,0,5.936-2.291,5.936-5.636v-24.968h-33.74V1092.094z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124156820370878797310000013014854750286412705_",
    gradientUnits: "userSpaceOnUse",
    x1: 1139.7336,
    y1: 74.8011,
    x2: 1106.7306,
    y2: 242.8176
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000124156820370878797310000013014854750286412705_)"
    },
    d: "M968.204,984.979h-0.469 c-18.375,0-33.271,15.621-33.271,34.372v32.575h33.739V984.979z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163040693783453128640000010261875232650859678_",
    gradientUnits: "userSpaceOnUse",
    x1: 1147.8407,
    y1: 76.392,
    x2: 1114.8375,
    y2: 244.4091
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000163040693783453128640000010261875232650859678_)"
    },
    d: "M934.465,1061.489 v24.968c0,3.345,2.657,5.636,5.936,5.636h27.804v-30.604H934.465z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025426425528582095450000002449732275180607111_",
    gradientUnits: "userSpaceOnUse",
    x1: 1178.3165,
    y1: 82.3802,
    x2: 1145.3134,
    y2: 250.3968
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000025426425528582095450000002449732275180607111_)"
    },
    d: "M978.045,984.979h-0.469 v66.947h33.74v-32.575C1011.316,1000.6,996.42,984.979,978.045,984.979z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156572151127734893480000010006242220933744779_",
    gradientUnits: "userSpaceOnUse",
    x1: 1188.8735,
    y1: 84.4517,
    x2: 1155.8704,
    y2: 252.4687
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000156572151127734893480000010006242220933744779_)"
    },
    d: "M977.576,1092.094 h27.804c3.278,0,5.936-2.291,5.936-5.636v-24.968h-33.74V1092.094z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056407470205341559790000007640422290209395342_",
    gradientUnits: "userSpaceOnUse",
    x1: 1275.0924,
    y1: 101.3877,
    x2: 1242.0894,
    y2: 269.4042
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000056407470205341559790000007640422290209395342_)"
    },
    d: "M1108.785,984.979 h-0.469c-18.375,0-33.271,15.621-33.271,34.372v32.575h33.739V984.979z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159428813925224195080000002676812801963934092_",
    gradientUnits: "userSpaceOnUse",
    x1: 1283.1998,
    y1: 102.9768,
    x2: 1250.1965,
    y2: 270.994
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000159428813925224195080000002676812801963934092_)"
    },
    d: "M1075.046,1061.489 v24.968c0,3.345,2.657,5.636,5.936,5.636h27.804v-30.604H1075.046z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059284164706523535010000004409456855458925721_",
    gradientUnits: "userSpaceOnUse",
    x1: 1313.6758,
    y1: 108.9637,
    x2: 1280.6727,
    y2: 276.9803
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000059284164706523535010000004409456855458925721_)"
    },
    d: "M1118.626,984.979 h-0.469v66.947h33.739v-32.575C1151.897,1000.6,1137.001,984.979,1118.626,984.979z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177470215774417755970000000340214610902750891_",
    gradientUnits: "userSpaceOnUse",
    x1: 1324.2324,
    y1: 111.0375,
    x2: 1291.2291,
    y2: 279.0544
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000177470215774417755970000000340214610902750891_)"
    },
    d: "M1118.157,1092.094 h27.804c3.278,0,5.936-2.291,5.936-5.636v-24.968h-33.739V1092.094z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152262551809678895330000009720378933936814505_",
    gradientUnits: "userSpaceOnUse",
    x1: 1410.4512,
    y1: 127.9741,
    x2: 1377.448,
    y2: 295.9907
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000152262551809678895330000009720378933936814505_)"
    },
    d: "M1249.366,984.979 h-0.469c-18.375,0-33.271,15.621-33.271,34.372v32.575h33.74V984.979z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056415032947058571590000011586305341447165317_",
    gradientUnits: "userSpaceOnUse",
    x1: 1418.5582,
    y1: 129.5653,
    x2: 1385.5549,
    y2: 297.5825
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000056415032947058571590000011586305341447165317_)"
    },
    d: "M1215.627,1061.489 v24.968c0,3.345,2.657,5.636,5.936,5.636h27.804v-30.604H1215.627z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050647728214690017440000008375033626213154467_",
    gradientUnits: "userSpaceOnUse",
    x1: 1449.0339,
    y1: 135.5538,
    x2: 1416.0308,
    y2: 303.5704
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000050647728214690017440000008375033626213154467_)"
    },
    d: "M1259.207,984.979 h-0.469v66.947h33.739v-32.575C1292.478,1000.6,1277.582,984.979,1259.207,984.979z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003085642979425460930000013469903361123097241_",
    gradientUnits: "userSpaceOnUse",
    x1: 1459.5907,
    y1: 137.6264,
    x2: 1426.5875,
    y2: 305.6433
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000003085642979425460930000013469903361123097241_)"
    },
    d: "M1258.738,1092.094 h27.804c3.278,0,5.936-2.291,5.936-5.636v-24.968h-33.739V1092.094z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181782399836777515320000016416964767104461708_",
    gradientUnits: "userSpaceOnUse",
    x1: 999.161,
    y1: 1502.1376,
    x2: 1041.1515,
    y2: 122.4142
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000181782399836777515320000016416964767104461708_)"
    },
    points: "720.217,563.144  1036.617,293.995 1335.462,556.513  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069380619278481608500000011449358689812569758_",
    gradientUnits: "userSpaceOnUse",
    x1: 1023.2603,
    y1: 313.4487,
    x2: 1031.5493,
    y2: 703.0253
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000069380619278481608500000011449358689812569758_)"
    },
    d: "M1325.952,554.799H730.925 c-1.292,0-2.525,0.241-3.392,0.663c-0.867,0.422-1.289,0.987-1.16,1.554l4.777,21.06c0.234,1.031,2.202,1.816,4.552,1.816 h590.249c2.526,0,4.575-0.903,4.575-2.017v-21.06C1330.526,555.702,1328.478,554.799,1325.952,554.799z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140708499470227888030000011034804557919109001_",
    gradientUnits: "userSpaceOnUse",
    x1: 967.007,
    y1: 1080.4528,
    x2: 798.9905,
    y2: 1614.506
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 734.765,
    y: 1395.833,
    style: {
      fill: "url(#SVGID_00000140708499470227888030000011034804557919109001_)"
    },
    width: 242.811,
    height: 73.844
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181074633021850374910000004923435627179667368_",
    gradientUnits: "userSpaceOnUse",
    x1: 1308.3638,
    y1: 1187.8459,
    x2: 1140.3472,
    y2: 1721.8995
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1108.785,
    y: 1399.403,
    style: {
      fill: "url(#SVGID_00000181074633021850374910000004923435627179667368_)"
    },
    width: 242.811,
    height: 73.844
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045591210229553790810000002520449889064936110_",
    gradientUnits: "userSpaceOnUse",
    x1: 1046.365,
    y1: 1451.5874,
    x2: 1048.1124,
    y2: 1486.3329
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 937.276,
    y: 1451.337,
    style: {
      fill: "url(#SVGID_00000045591210229553790810000002520449889064936110_)"
    },
    width: 219.307,
    height: 22.953
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163788154729835975960000014034012048353878947_",
    gradientUnits: "userSpaceOnUse",
    x1: 1275.6851,
    y1: 101.5051,
    x2: 1242.682,
    y2: 269.5215
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163788154729835975960000014034012048353878947_)"
    },
    d: "M964.455,1271.115 c0-11.477,36.505-18.171,81.537-18.171s81.537,6.695,81.537,18.171H964.455z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178167822357913349930000011750291010883368635_",
    gradientUnits: "userSpaceOnUse",
    x1: 1251.951,
    y1: 96.8424,
    x2: 1218.9479,
    y2: 264.8591
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 963.518,
    y: 1278.766,
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000178167822357913349930000011750291010883368635_)"
    },
    width: 78.725,
    height: 172.149
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049183789992030712160000009743831554220211129_",
    gradientUnits: "userSpaceOnUse",
    x1: 1334.0687,
    y1: 112.9716,
    x2: 1301.0656,
    y2: 280.9883
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1049.741,
    y: 1278.766,
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000049183789992030712160000009743831554220211129_)"
    },
    width: 76.851,
    height: 172.149
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044867311607042155070000007058152698353315241_",
    gradientUnits: "userSpaceOnUse",
    x1: 1057.0946,
    y1: 58.5672,
    x2: 1024.0914,
    y2: 226.5839
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000044867311607042155070000007058152698353315241_)"
    },
    d: "M852.928,1188.22h-45.455 c-6.988,0-12.652,6.201-12.652,13.332v89.958h58.107V1188.22z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146485184857038387730000016914998205861826953_",
    gradientUnits: "userSpaceOnUse",
    x1: 1118.2224,
    y1: 70.576,
    x2: 1085.2192,
    y2: 238.5929
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000146485184857038387730000016914998205861826953_)"
    },
    d: "M904.005,1188.22h-43.58 v103.29h56.232v-89.958C916.658,1194.421,910.993,1188.22,904.005,1188.22z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127737559428355970180000017703012345380289724_",
    gradientUnits: "userSpaceOnUse",
    x1: 1100.0491,
    y1: 67.0054,
    x2: 1067.0459,
    y2: 235.022
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000127737559428355970180000017703012345380289724_)"
    },
    d: "M794.821,1321.1 c0,7.131,5.665,12.49,12.652,12.49h96.532c6.988,0,12.652-5.36,12.652-12.49v-21.94H794.821V1321.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172420716930482459120000009556924420686499743_",
    gradientUnits: "userSpaceOnUse",
    x1: 1421.4111,
    y1: 130.1295,
    x2: 1388.408,
    y2: 298.1462
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000172420716930482459120000009556924420686499743_)"
    },
    d: "M1231.542,1186.993 h-45.455c-6.988,0-12.652,6.201-12.652,13.332v89.958h58.107V1186.993z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089551601417086561400000016725745338592723343_",
    gradientUnits: "userSpaceOnUse",
    x1: 1482.5394,
    y1: 142.136,
    x2: 1449.5363,
    y2: 310.1529
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000089551601417086561400000016725745338592723343_)"
    },
    d: "M1282.62,1186.993h-43.58 v103.29h56.232v-89.958C1295.272,1193.194,1289.608,1186.993,1282.62,1186.993z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101067513233237812290000008026192517782419646_",
    gradientUnits: "userSpaceOnUse",
    x1: 1464.366,
    y1: 138.5656,
    x2: 1431.3629,
    y2: 306.5821
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000101067513233237812290000008026192517782419646_)"
    },
    d: "M1173.435,1319.873 c0,7.131,5.665,12.49,12.652,12.49h96.532c6.988,0,12.652-5.36,12.652-12.49v-21.939h-121.837V1319.873z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003087794312020222060000014909616747243397010_",
    gradientUnits: "userSpaceOnUse",
    x1: 1036.6167,
    y1: 81.0444,
    x2: 1036.6167,
    y2: 300.066
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000003087794312020222060000014909616747243397010_)"
    },
    cx: 1036.617,
    cy: 444.57,
    rx: 48.091,
    ry: 49.075
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076577131392850770390000009876636375120099750_",
    gradientUnits: "userSpaceOnUse",
    x1: 1111.8951,
    y1: 173.9742,
    x2: 996.2527,
    y2: 589.6627
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000076577131392850770390000009876636375120099750_)"
    },
    cx: 1036.617,
    cy: 444.57,
    rx: 39.675,
    ry: 40.487
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144338729799360637110000004986170861917784511_",
    gradientUnits: "userSpaceOnUse",
    x1: 1015.2272,
    y1: 312.8343,
    x2: 1031.2998,
    y2: 632.3967
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000144338729799360637110000004986170861917784511_)"
    },
    d: "M720.217,563.144l308.326-253.132 c4.698-3.857,11.408-3.805,16.047,0.125l290.871,246.375l16.339-17.027c3.418-3.562,3.152-9.336-0.578-12.555l-307.114-265.068 c-4.343-3.749-10.687-3.806-15.095-0.138L700.971,534.748c-2.81,2.339-2.98,6.661-0.361,9.221L720.217,563.144z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046310389800183141320000012334275282307102362_",
    gradientUnits: "userSpaceOnUse",
    x1: 1466.9006,
    y1: 1729.6255,
    x2: 1447.5984,
    y2: 713.0788
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000046310389800183141320000012334275282307102362_)"
    },
    d: "M1490.203,1530.827h-67.729V822.39 c0-19.67,15.946-35.617,35.617-35.617h2.679c16.255,0,29.433,13.177,29.433,29.433V1530.827z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000053537777032159815630000011508758146929993608_",
    gradientUnits: "userSpaceOnUse",
    x1: 1467.0867,
    y1: 754.1169,
    x2: 1448.3223,
    y2: 1238.8611
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000053537777032159815630000011508758146929993608_)"
    },
    d: "M1637.478,1150.227h-361.199 c-18.464,0-33.433-14.968-33.433-33.433v-197.95c0-18.464,14.968-33.433,33.433-33.433h361.199 c18.464,0,33.433,14.968,33.433,33.433v197.95C1670.911,1135.259,1655.943,1150.227,1637.478,1150.227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1627.989,1142.709h-341.302c-18.464,0-33.433-14.968-33.433-33.433V930.539 c0-18.464,14.968-33.433,33.433-33.433h341.302c18.464,0,33.433,14.968,33.433,33.433v178.737 C1661.422,1127.74,1646.453,1142.709,1627.989,1142.709z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1450.05,1533.411c-1.219-0.075-2.348-0.641-3.147-1.584 c-11.651-13.737-96.962-121.691-2.256-233.62c89.905-106.255,132.464-129.921,134.046-188.419 c0.185-6.831,9.046-9.147,12.451-3.263c25.448,43.979,67.705,147.918-40.998,226.607 c-119.911,86.802-103.385,170.602-95.54,194.175C1455.641,1530.423,1453.269,1533.609,1450.05,1533.411L1450.05,1533.411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1465.786,1534.38c-2.887-0.178-5.317-2.253-5.972-5.128 c-4.457-19.568-17.271-92.985,34.694-116.702c57.205-26.108,108.791,26.129,148.788-20.923c2.104-2.476,6.076-0.764,5.771,2.499 c-2.166,23.142-15.399,77.375-90.847,93.871c-80.756,17.657-89.234,27.914-86.714,39.637 C1472.284,1531.248,1469.406,1534.602,1465.786,1534.38L1465.786,1534.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.47,
      fill: "#FFFFFF"
    },
    d: "M1580.21,1169.19c-0.679,4.383-1.707,8.526-2.993,12.659 c-1.258,4.126-2.758,8.171-4.426,12.143c-3.295,7.969-7.392,15.582-11.955,22.885c-9.196,14.578-20.658,27.643-33.519,38.963 c-6.415,5.629-13.33,10.881-20.195,15.674c-6.684,4.672-13.067,9.816-19.138,15.322c-12.152,11.011-22.983,23.537-32.365,37.079 c-18.682,27.098-31.006,59.016-33.394,92.176c-1.246,16.546-0.042,33.297,3.381,49.622c3.399,16.348,9.204,32.167,16.436,47.293 c0.39,0.806,0.066,1.782-0.724,2.18c-0.759,0.382-1.678,0.081-2.094-0.657c-8.249-14.863-14.771-30.837-18.959-47.527 c-2.126-8.333-3.648-16.846-4.537-25.441c-0.837-8.597-1.119-17.273-0.686-25.924c0.78-17.315,4.284-34.486,9.949-50.831 c5.684-16.355,13.645-31.834,23.222-46.132c9.573-14.317,20.943-27.341,33.571-38.926c6.328-5.781,12.992-11.193,20-16.132 c6.867-4.753,13.365-9.545,19.606-14.911c12.464-10.611,23.819-22.628,33.358-36.079c4.84-6.675,9.145-13.753,13.015-21.084 c3.782-7.338,7.255-15.041,9.584-22.909l0.031-0.102c0.232-0.786,1.045-1.23,1.815-0.993 C1579.898,1167.753,1580.323,1168.467,1580.21,1169.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.47,
      fill: "#FFFFFF"
    },
    d: "M1461.41,1521.212c0.197-0.736,0.07-1.396-0.004-2.079l-0.212-2.036l-0.347-4.075 c-0.195-2.719-0.339-5.442-0.422-8.167c-0.163-5.45-0.109-10.911,0.205-16.364c0.658-10.891,2.26-21.823,5.778-32.274 c3.476-10.377,9.153-20.475,17.958-27.463c4.39-3.436,9.436-6.029,14.751-7.558c5.307-1.573,10.836-2.171,16.291-2.101 c21.425,0.884,42.551,3.443,63.673,5.215c10.514,0.784,21.162,1.387,31.265-0.82c2.509-0.574,4.966-1.331,7.335-2.313 c2.339-1.04,4.626-2.223,6.734-3.711c4.249-2.927,7.891-6.762,11.09-10.954l0.01-0.013c0.441-0.577,1.256-0.681,1.822-0.231 c0.558,0.443,0.664,1.26,0.244,1.837c-3.228,4.424-6.985,8.573-11.492,11.826c-2.235,1.649-4.679,2.989-7.186,4.164 c-2.534,1.118-5.161,1.989-7.826,2.659c-10.752,2.459-21.631,1.904-32.256,1.24c-10.66-0.722-21.221-1.919-31.799-2.843 c-10.546-0.931-21.209-1.795-31.676-2.241c-5.159-0.113-10.329,0.407-15.246,1.818c-4.929,1.37-9.565,3.706-13.637,6.83 c-8.21,6.265-13.811,15.662-17.348,25.641c-3.584,10.031-5.364,20.73-6.203,31.451c-0.407,5.37-0.557,10.766-0.493,16.16 c0.035,2.697,0.127,5.394,0.273,8.088l0.271,4.036l0.174,2.013c0.067,0.665,0.087,1.353,0.455,1.962 c0.35,0.578,0.174,1.336-0.392,1.693c-0.567,0.357-1.309,0.178-1.66-0.4c-0.182-0.301-0.221-0.65-0.138-0.966L1461.41,1521.212z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016766149168611378790000013166631426335860354_",
    gradientUnits: "userSpaceOnUse",
    x1: 1259.624,
    y1: 574.9216,
    x2: 1327.6239,
    y2: 1118.9213
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016766149168611378790000013166631426335860354_)"
    },
    d: "M1342.433,1059.946h-16.841v-40.5 h-22.227v40.5h-16.84v-92.372h16.84v36.708h22.227v-36.708h16.841V1059.946z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127017778705746171630000005467802256412765842_",
    gradientUnits: "userSpaceOnUse",
    x1: 1332.1892,
    y1: 565.851,
    x2: 1400.189,
    y2: 1109.8508
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127017778705746171630000005467802256412765842_)"
    },
    d: "M1420.693,1013.634 c0,15.289-2.807,27.041-8.421,35.256c-5.614,8.213-13.642,12.32-24.084,12.32c-10.485,0-18.534-4.097-24.147-12.289 c-5.614-8.192-8.421-19.997-8.421-35.413c0-15.289,2.807-27.01,8.421-35.161c5.613-8.15,13.703-12.226,24.27-12.226 c10.443,0,18.45,4.097,24.023,12.289C1417.907,986.602,1420.693,998.344,1420.693,1013.634z M1372.834,1013.634 c0,10.53,1.299,18.555,3.901,24.072c2.6,5.518,6.418,8.276,11.454,8.276c10.154,0,15.231-10.782,15.231-32.349 c0-21.566-5.037-32.349-15.107-32.349c-5.118,0-8.978,2.748-11.578,8.245C1374.133,995.027,1372.834,1003.062,1372.834,1013.634 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000055670424064541270690000002202246962152688053_",
    gradientUnits: "userSpaceOnUse",
    x1: 1395.3472,
    y1: 557.9564,
    x2: 1463.347,
    y2: 1101.9567
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000055670424064541270690000002202246962152688053_)"
    },
    d: "M1475.116,1034.484 c0,8.636-2.136,15.249-6.407,19.839c-4.273,4.591-10.433,6.887-18.482,6.887c-7.884,0-14.592-1.58-20.123-4.739v-16.996 c6.769,4.507,12.981,6.76,18.636,6.76c3.22,0,5.644-0.906,7.275-2.717c1.631-1.81,2.446-4.275,2.446-7.392 c0-3.075-0.971-5.885-2.91-8.435c-1.94-2.547-5.139-5.38-9.597-8.498c-3.88-2.737-6.821-5.36-8.823-7.866 c-2.002-2.506-3.55-5.317-4.643-8.435c-1.095-3.116-1.641-6.738-1.641-10.867c0-7.918,2.157-14.194,6.47-18.828 c4.313-4.633,10.102-6.95,17.367-6.95c6.934,0,13.6,1.981,19.999,5.94l-5.573,13.773c-1.981-1.179-4.055-2.233-6.222-3.159 c-2.167-0.926-4.489-1.39-6.966-1.39c-2.723,0-4.819,0.915-6.284,2.748c-1.466,1.832-2.198,4.328-2.198,7.487 c0,3.118,0.876,5.834,2.631,8.15c1.753,2.317,4.818,4.95,9.194,7.898c5.901,4.044,10.019,8.173,12.351,12.384 C1473.949,1024.29,1475.116,1029.092,1475.116,1034.484z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124150365211982965170000018199337712798512806_",
    gradientUnits: "userSpaceOnUse",
    x1: 1452.6307,
    y1: 550.7961,
    x2: 1520.6305,
    y2: 1094.7959
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124150365211982965170000018199337712798512806_)"
    },
    d: "M1514.061,1059.946h-16.779v-77.271 h-17.336v-15.101h51.452v15.101h-17.337V1059.946z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061454150895405969910000013615736695058455436_",
    gradientUnits: "userSpaceOnUse",
    x1: 1502.8026,
    y1: 544.5245,
    x2: 1570.8025,
    y2: 1088.5244
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000061454150895405969910000013615736695058455436_)"
    },
    d: "M1581.858,1059.946h-40.802v-92.372 h40.802v14.848h-23.962v21.988h22.227v14.911h-22.227v25.588h23.962V1059.946z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095308335994472450960000001697317867338200718_",
    gradientUnits: "userSpaceOnUse",
    x1: 1550.8972,
    y1: 538.5125,
    x2: 1618.897,
    y2: 1082.5121
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000095308335994472450960000001697317867338200718_)"
    },
    d: "M1595.045,1059.946v-92.372h16.84 v77.334h23.343v15.037H1595.045z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHostel);
export default __webpack_public_path__ + "static/media/hostel.0e8a9e66cc80282270bd0cccf6699824.svg";
export { ForwardRef as ReactComponent };